<template>
  <b-container v-if="this.type" fluid>
    <h1>
      {{title || $appConfig.models[this.type].title}}
      <b-button variant="secondary" size="sm" :to="'/new-company-shipping/'" v-translate>+ NEW Company Shipping</b-button>
      <b-button variant="secondary" size="sm" v-b-modal.modalCsvImport v-translate>CSV Bulk Import</b-button>
    </h1>

    <b-card no-body class="filters">
      <b-tabs card v-model="tabIndex">
        <b-tab :title="$gettext('Quick Filters')" active>
          <b-card-text>
            <form @submit.prevent="updateQuickFilters">
              <b-row>
                <b-col class="text-center filter-actions">
                  <b-form-checkbox v-model="highPerformanceRequest" :value="true" :unchecked-value="false" class="d-inline-block"><translate>Clustering Minimal Data</translate></b-form-checkbox>
                  <font-awesome-icon icon="info-circle" class="text-info" size="2x" style="vertical-align: middle" v-b-tooltip.hover.bottom="$gettext('This list shows the SLA expired and on-time *AND* DRAFT status shippings by default. Please use one or more filters if you need anything else.')" />
                  <b-button size="sm" variant="success" type="submit" :disabled="noDateRange || outOfDateRange" v-translate>
                    Apply Filters
                  </b-button>
                  <font-awesome-icon v-if="noDateRange || outOfDateRange" class="no-border text-warning" icon="exclamation-triangle" style="vertical-align:middle" v-b-tooltip.hover.bottom="$gettext('You must select a Created or Updated Date Range and the range must be equal or less than 90 days to be able to search shippings.')" />
                  <b-badge size="md" @click="resetQuickFilters" v-translate>Reset Filters</b-badge> <b-badge size="sm" @click="saveCurrentQuickFilters" v-translate>Save this Filters' Set</b-badge>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="6" md="2">
                  <b-form-group>
                    <label for="filter-statuses" v-translate>Statuses</label>
                    <b-form-checkbox-group stacked id="filter-statuses" v-model="filter.statuses" :options="statuses" :disabled="filter.readyWithIncidence !== null || filter.needUrgentAction"></b-form-checkbox-group>
                  </b-form-group>
                  <div class="form-group">
                    <label for="filter-scheduleds" v-translate>Scheduleds?</label>
                    <b-form-radio-group stacked id="filter-scheduleds" v-model="filter.scheduleds">
                      <b-form-radio value="indeterminate"><translate>All</translate></b-form-radio>
                      <b-form-radio value="false"><translate>Futures Only</translate></b-form-radio>
                      <b-form-radio value="null"><translate>Without Futures</translate></b-form-radio>
                    </b-form-radio-group>
                  </div>
                  <b-form-group>
                    <b-form-checkbox id="filter-cut-time" v-model="filter.cutTime" :value="1" :unchecked-value="false"><translate>Before Cut Hour</translate></b-form-checkbox>
                  </b-form-group>
                  <b-form-group>
                    <b-form-checkbox id="filter-working-on-sat" v-model="filter.workingOnSat" :value="1" :unchecked-value="false"><translate>Working on Saturday</translate></b-form-checkbox>
                    <b-form-checkbox id="filter-working-on-sun" v-model="filter.workingOnSun" :value="1" :unchecked-value="false"><translate>Working on Sunday</translate></b-form-checkbox>
                  </b-form-group>
                  <div class="form-group">
                    <label for="search-with-tour" v-translate>With/without Tour Assigned</label>
                    <b-form-radio-group stacked id="search-with-tour" v-model="filter.withoutTour" :disabled="filter.statuses.indexOf('READY') === -1 && filter.statuses.indexOf('READYATSTORE') === -1 && filter.statuses.indexOf('WAITING') === -1 && filter.readyWithIncidence === null">
                      <b-form-radio value="indeterminate"><translate>Both</translate></b-form-radio>
                      <b-form-radio value="false"><translate>With</translate></b-form-radio>
                      <b-form-radio value="null"><translate>Without</translate></b-form-radio>
                    </b-form-radio-group>
                  </div>
                </b-col>
                <b-col cols="6" md="2">
                  <b-form-group>
                    <label for="filter-types" v-translate>Types</label>
                    <b-form-checkbox
                      v-model="allTypesSelected"
                      :indeterminate="indeterminateTypesSelected"
                      aria-describedby="shippingTypesSelect"
                      aria-controls="shippingTypesSelect"
                      @change="toggleAllTypes"
                    >
                      {{ allTypesSelected ? 'Un-select All' : 'Select All' }}
                    </b-form-checkbox>

                    <b-form-checkbox-group stacked class="ml-3" id="filter-types" v-model="filter.types" :options="shippingTypesSelect"></b-form-checkbox-group>
                  </b-form-group>
                  <b-form-group>
                    <label for="filter-sizes" v-translate>Sizes</label>
                    <b-form-checkbox-group id="filter-sizes" stacked v-model="filter.sizes" :options="shippingSizesSelect"></b-form-checkbox-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                  <div class="form-group">
                    <label for="search-id" v-translate>Shipping ID</label>
                    <textarea id="search-id" v-model.lazy="filter.shippingId" type="text" class="mb-2 col-12 form-control" />
                  </div>
                  <div class="form-group">
                    <label for="search-destination-contact-name" v-translate>Destination Contact Name</label>
                    <input id="search-destination-contact-name" v-model.lazy="filter.destinationContactName" type="text" class="mb-2 col-12 form-control">
                  </div>
                  <div class="form-group">
                    <label for="search-destination-contact-email" v-translate>Destination Contact Email (exact)</label>
                    <input id="search-destination-contact-email" v-model.lazy="filter.destinationContactEmail" type="text" class="mb-2 col-12 form-control">
                  </div>
                  <div class="form-group">
                    <label for="search-destination-contact-name" v-translate>Origin Near...</label>
                    <div v-if="filter.nearOrigin !== null">
                      <p class="mb-2">
                        <small>
                          lat: {{quickFilters.nearOrigin[2].lat}},
                          lng: {{quickFilters.nearOrigin[2].lng}},
                          radius: {{parseInt(quickFilters.nearOrigin[2].radius)}} m
                        </small>
                      </p>
                    </div>
                    <div>
                      <b-button size="sm" v-b-modal.modalCirclePicker v-translate>Launch Area Picker</b-button>
                      <b-button size="sm" variant="danger" @click="filter.nearOrigin = null" v-if="filter.nearOrigin !== null" v-translate>
                        Clear Area
                      </b-button>
                    </div>

                    <b-modal size="xl" id="modalCirclePicker" ref="modalCirclePicker" title="Origin Near... Picker" hide-footer>
                      <circle-picker fit-once geolocate :set-circle-center="filter.nearOrigin !== null ? [quickFilters.nearOrigin[2].lat, quickFilters.nearOrigin[2].lng] : []" :set-circle-radius="filter.nearOrigin !== null ? quickFilters.nearOrigin[2].radius : 500" @circle-picked="circlePicked" @cancel="$refs.modalCirclePicker.hide()" />
                    </b-modal>

                  </div>
                  <div class="form-group">
                    <label for="search-origin-address" v-translate>Origin Address</label>
                    <address-autocomplete id="search-origin-address" v-if="!fromAddressAcInput" @selected="setFromAddress" static-items :minCharacter="4" class="mb-2" />
                    <p v-else>
                      {{fromAddressAcInput}}
                      <b-button pill variant="danger" size="sm" @click="fromAddressAcInput = ''; filter.originAddress = null" class="px-3">✕</b-button>
                    </p>
                  </div>
                  <div class="form-group">
                    <label for="search-destination-address">
                      <translate>Destination Address</translate>
                      (<a href="#" @click.prevent="toAddressRawInput = !toAddressRawInput" v-translate>toggle method</a>,
                      <span v-translate="{current: toAddressRawInput ? $gettext('classic') : $gettext('place_id')}">current: <strong>%{current}</strong></span>)
                    </label>
                    <div v-if="!toAddressRawInput">
                      <address-autocomplete id="search-destination-address" v-if="!toAddressAcInput" @selected="setToAddress" static-items :minCharacter="4" class="mb-2" />
                      <p v-else>
                        {{toAddressAcInput}}
                        <b-button pill variant="danger" size="sm" @click="toAddressAcInput = ''; filter.destinationAddress = null" class="px-3">✕</b-button>
                      </p>
                    </div>
                    <div v-else>
                      <input id="search-destination-address" v-model.lazy="filter.destinationAddress" type="text" class="mb-2 col-12 form-control">
                    </div>
                  </div>
                  <b-form-group v-if="!$cookies.get('bypassCountry')">
                    <label for="search-destination-area" v-translate>Destination in Area</label>
                    <b-form-select v-model="filter.destinationArea" :options="areasSelect" multiple :select-size="4">
                      <template #first><option :value="null" v-translate>All</option></template>
                    </b-form-select>
                  </b-form-group>
                  <b-row>
                    <div class="form-group col-6">
                      <label for="search-external-code" v-translate>External Code/Order (exact)</label>
                      <textarea id="search-external-code" v-model.lazy="filter.externalCode" type="text" class="mb-2 col-12 form-control" />
                    </div>
                    <div class="form-group col-6">
                      <label for="search-pickup-id" v-translate>Pickup or Return Shipping ID (exact)</label>
                      <input id="search-pickup-id" v-model.lazy="filter.pickupId" type="text" class="mb-2 col-12 form-control">
                    </div>
                  </b-row>
                  <div class="form-group">
                    <b-form-checkbox v-model="filter.forReview" :value="1" :disabled="filter.statuses.length > 0 && filter.statuses.indexOf('DRAFT') === -1"><translate>With address to review</translate></b-form-checkbox>
                  </div>
                  <b-form-group>
                    <label for="filter-sla" v-translate>SLA</label>
                    <b-form-checkbox-group id="filter-sla" v-model="filter.sla" :options="[{value: 'expired', text: $gettext('Expired')}, {value: 'on-time', text: $gettext('On time')}, {value: 'tomorrow', text: $gettext('Tomorrow')}, {value: 'future', text: $gettext('Future')}]"></b-form-checkbox-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                  <div class="form-group"><br>
                    <tag-autocomplete ref="tagAc" @selected="onSearchTagSelected" />
                    <b-badge v-for="(item, index) in filter.tag" :key="index">
                      {{ item.name }} <b-badge variant="danger" href="#" @click.prevent="removeTagFromFilters(index)">×</b-badge>
                    </b-badge>&nbsp;
                  </div>
                  <b-form-group>
                    <company-autocomplete ref="companyAc" @selected="onSearchCompanySelected" />
                    <b-badge v-for="(item, index) in filter.company" :key="index">
                      {{ item.name }} <b-badge variant="danger" href="#" @click.prevent="removeCompanyFromFilters(index)">×</b-badge>
                    </b-badge>&nbsp;
                  </b-form-group>
                  <div class="form-group">
                    <user-autocomplete ref="userAc" @selected="onSearchClientSelected" with-picture />
                    <b-badge v-for="(item, index) in filter.client" :key="index">
                      {{ item.email }} <b-badge variant="danger" href="#" @click.prevent="removeClientFromFilters(index)">×</b-badge>
                    </b-badge>&nbsp;
                  </div>
                  <div class="form-group">
                    <user-autocomplete ref="courierAc" :placeholder="$gettext('Courier Name or Email')" @selected="onSearchCourierSelected" :restrictToRoles="['courier']" with-picture />
                    <b-badge v-for="(item, index) in filter.courier" :key="index">
                      {{ item.email }} <b-badge variant="danger" href="#" @click.prevent="removeCourierFromFilters(index)">×</b-badge>
                    </b-badge>&nbsp;
                  </div>
                  <div class="form-group">
                    <label for="search-with-tour" v-translate>READY with/without INCIDENCE</label>
                    <b-form-radio-group  id="search-ready-with-incidence" v-model="filter.readyWithIncidence">
                      <b-form-radio :value="null"><translate>Off</translate></b-form-radio>
                      <b-form-radio :value="1"><translate>With</translate></b-form-radio>
                      <b-form-radio :value="0"><translate>Without</translate></b-form-radio>
                    </b-form-radio-group>
                  </div>
                  <b-form-group>
                    <b-form-checkbox v-model="filter.needUrgentAction" :value="true" :unchecked-value="false">
                    <translate>Needs URGENT action</translate>
                    </b-form-checkbox>
                  </b-form-group>
                  <b-form-group>
                    <b-form-checkbox v-model="filter.roundtrips" :value="true" :unchecked-value="false">
                    <translate>Roundtrips</translate>
                    </b-form-checkbox>
                    <b-form-radio-group v-model="filter.roundtripLegs" :disabled="!filter.roundtrips">
                      <b-form-radio value="all"><translate>All</translate></b-form-radio>
                      <b-form-radio value="forth"><translate>Roundtrip Forths</translate></b-form-radio>
                      <b-form-radio value="back"><translate>Roundtrip Backs</translate></b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                  <b-form-group v-if="universe.has3p">
                    <label for="filter-3p" v-translate>3P</label>
                    <b-form-radio-group  id="filter-3p" v-model="filter.isOutsourced">
                      <b-form-radio :value="false"><translate>Without 3P</translate></b-form-radio>
                      <b-form-radio :value="1"><translate>3P Only</translate></b-form-radio>
                      <b-form-radio :value="null"><translate>Both</translate></b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                  <b-form-group v-if="universe.has3p">
                    <label for="filter-3p-courier-company" v-translate>3P Provider</label>
                    <company-autocomplete ref="courierCompanyAc" @selected="onSearchCourierCompanySelected" :disabled="filter.isOutsourced !== 1" :restrict-to="[['relationship', 'eq', 'provider']]" />
                    <b-badge v-for="(item, index) in filter.courierCompany" :key="index">
                      {{ item.name }} <b-badge variant="danger" href="#" @click.prevent="removeCourierCompanyFromFilters(index)">×</b-badge>
                    </b-badge>&nbsp;
                  </b-form-group>
                  <b-form-group v-if="!$cookies.get('bypassCountry') && warehousesSelect.length > 0">
                    <label for="filter-warehouse" v-translate>Select Origin Warehouse</label>
                    <b-form-select v-model="filter.warehouse" :options="warehousesSelect">
                      <template slot="first">
                        <option :value="null" v-translate>None</option>
                      </template>
                    </b-form-select>
                  </b-form-group>

                  <b-form-group v-if="!$cookies.get('bypassCountry') && deliveryTimeRangesSelect.length > 0">
                    <label for="filter-time-range" v-translate>Select Delivery Time Range</label>
                    <b-form-checkbox v-model="filter.deliveryTimeRangeNot" :disabled="!filter.deliveryTimeRange"><translate>NOT IN</translate></b-form-checkbox>
                    <b-form-select v-model="filter.deliveryTimeRange" :options="deliveryTimeRangesSelect">
                      <template slot="first">
                        <option :value="null" v-translate>None</option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <label class="" for="inline-form-input-name" v-translate>Created At Date Range <em>(90 days max.)</em></label><label v-show="filter.createdDateRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="resetCreatedDateRange" v-translate>reset range</a>]</label>
                  <date-range-picker
                    v-if="datepickerLocalized"
                    v-model="createdDateRange"
                    @update="filter.createdDateRangeActive++"
                    :locale-data="locale1"
                    :opens="opens"
                    class="mb-2 w-100"
                    :ranges="ranges"
                  >
                    <div slot="input" slot-scope="picker">
                      <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                      <span v-if="filter.createdDateRangeActive === 0" style="vertical-align: middle">...</span>
                      <span v-else style="vertical-align: middle">{{moment(createdDateRange.startDate).format('L')}} - {{moment(createdDateRange.endDate).format('L')}}</span>
                    </div>
                  </date-range-picker>
                </b-col>
                <b-col>
                  <label class="" for="inline-form-input-name" v-translate>Updated At Date Range <em>(90 days max.)</em></label><label v-show="filter.updatedDateRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="fullResetUpdatedDateRange" v-translate>reset range</a>]</label>
                  <date-range-picker
                    v-if="datepickerLocalized"
                    v-model="updatedDateRange"
                    @update="filter.updatedDateRangeActive++"
                    :locale-data="locale2"
                    :opens="opens"
                    class="mb-2 w-100"
                    :ranges="ranges"
                  >
                    <div slot="input" slot-scope="picker">
                      <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                      <span v-if="filter.updatedDateRangeActive === 0" style="vertical-align: middle">...</span>
                      <span v-else style="vertical-align: middle">{{moment(updatedDateRange.startDate).format('L')}} - {{moment(updatedDateRange.endDate).format('L')}}</span>
                    </div>
                  </date-range-picker>
                </b-col>
              </b-row>
            </form>
          </b-card-text>
        </b-tab>
        <b-tab :title="$gettext('Advanced Filters')">
          <b-card-text>
            <b-row>
              <b-col lg="12" class="my-1">
                <listing-filter :type="type" @save-filter="saveCurrentAdvancedFilters" :filter-fields="filterFields" :pre-filters="preFilters" @refresh="refreshTable" ref="listingFilters" />
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
        <b-tab :title="$gettext('Saved Filters')" :disabled="savedQuickSearches.length === 0">
          <b-list-group>
            <b-list-group-item v-for="(savedQuickSearch, index) in savedQuickSearches" :key="index" :href="savedQuickSearch.url" class="d-flex justify-content-between align-items-center">
              {{ savedQuickSearch.name }}
              <b-badge href="#" @click.stop.prevent="deleteSavedQuickSearch(index)" variant="danger">✕</b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-alert v-if="shippingCollection.length" show variant="succsess" style="background:#d0f6f0" class="routifier-collection">
      <h3>
        <translate>Shipping Collection</translate>
        <small v-if="shippingCollection.length > 0">
          (
            <span v-translate="{qty: shippingCollection.length}">%{qty} item/s</span>
          <a href="#" @click.prevent="copyToClipboard(shippingCollection.join('\n'), $gettext('Collection IDs'))" class="text-secondary" :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
          )
        </small>
        <b-button size="sm" v-b-modal.modalCollectionMap v-translate>Map</b-button>
        <b-button size="sm" variant="primary" v-b-modal.modalClustersMap :disabled="collectionHas3P" v-translate>Suggest Clusters</b-button>
        <b-button size="sm" variant="danger" @click="clearShippingCollection" v-translate>Clear Collection</b-button>
        <b-button size="sm" variant="warning" @click="bulkRecalculateBudget" :disabled="(!isSuperAdmin && !isOperator && !isOperatorSupervisor) || !collectionIsEditable || collectionHas3P" v-translate>Recalculate Budgets</b-button>
      </h3>
      <b-row>
        <b-col md="6" lg="7" xl="8">
          <b-badge v-for="(item, index) in shippingCollection" :key="index" :title="'Status: ' + shippingCollectionObject.find(x => x.id === item).status">
            {{shippingCollectionObject[item]}}
            {{ item | uuid }} <b-badge variant="danger" href="#" @click.prevent="removeFromRoutifier(index)">×</b-badge>
          </b-badge>&nbsp;
        </b-col>
        <b-col md="6" lg="5" xl="4">
          <b-card no-body bg-variant="light">
            <b-tabs card active-nav-item-class="bg-light">
              <b-tab :title="$gettext('Routifier')" active :disabled="collectionHas3P">
                <b-row class="mt-2">
                  <b-col>
                    <b-button variant="success" @click="sendToRoutifier" v-translate>Send to Routifier</b-button>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab :title="$gettext('Status')" :disabled="collectionHas3P">
                <b-form @submit.prevent="updateStatus">
                  <div class="mb-1">
                    <label for="change-status" v-translate>New Status</label>
                    <div class="input-group">
                      <b-form-select v-model="newShippingStatus" class="mb-2 mr-sm-2 mb-sm-0" required id="change-status">
                        <option :value="null" v-translate>Select an option</option>
                        <option :value="status" v-for="(status, index) in Object.keys(statusesMap)" :key="index">
                          {{ status }}
                        </option>
                      </b-form-select>
                    </div>
                  </div>
                  <div v-if="newShippingStatus === 'READY'">
                    <b-form-group class="mt-2">
                      <label for="scheduled-at" v-translate>Schedule Date (optional)</label>
                      <input type="date" v-model="reScheduledAt" class="form-control">
                    </b-form-group>
                  </div>
                  <div v-if="newShippingStatus === 'CONFIRMED' && (!statusCourier || !statusCourier.id)">
                    <div class="invalid-feedback d-block" v-translate>
                      CONFIRMED status requires to search and select a courier below before submit the new status.
                    </div>
                  </div>
                  <div class="mb-3" v-if="newShippingStatus === 'CONFIRMED'">
                    <label for="search-courier" v-translate>Select courier by name or email</label>
                    <user-autocomplete v-if="!statusCourier || !statusCourier.id" ref="statusCourierAc" placeholder="Courier Name or Email" @selected="onStatusSearchCourierSelected" :restrictToRoles="['courier']" with-picture />
                    <div style="position: relative" class="mt-2" v-else>
                      <span class="bg-danger text-white d-block text-center" style="cursor: pointer; width: 1rem; height: 1rem; line-height: 1rem; position: absolute; top: 0; left: 0" href="#" @click.prevent="statusCourier = {}">×</span>
                      <user-card :user="statusCourier" />
                    </div>
                  </div>
                  <div v-if="newShippingStatus === 'INCIDENCE'">
                    <br>
                    <b-form-group>
                      <label for="incidence-desc" v-translate>Incidence type</label>
                      <b-form-radio-group v-model="incidenceDetails" name="incidenceDetails" required>
                        <b-form-radio v-for="(item, index) in shippingStatusReasons[shipping.status]" :value="{reason: item.name, reason_id: item.reason_id}" class="w-100" :key="index">
                          {{ item.description }}
                        </b-form-radio>
                        <b-form-radio :value="{reason: 'other'}" class="w-100"><translate>Other</translate></b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group v-if="incidenceDetails.reason === 'other'">
                      <label for="incidence-desc" v-translate>Incidence Description</label>
                      <div class="input-group">
                        <b-form-textarea
                          id="incidence-desc"
                          v-model="newShippingStatusMeta"
                          rows="3"
                          max-rows="6"
                          :state="validateIncidenceDesc"
                          required
                        />
                        <b-form-invalid-feedback :state="validateIncidenceDesc" v-translate>
                          "Other" INCIDENCE status requires a description for the client. Please be brief but descriptive.
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="validateIncidenceDesc" v-translate>
                          Alright.
                        </b-form-valid-feedback>
                      </div>
                    </b-form-group>
                  </div>
                  <div class="mb-3" v-if="newShippingStatus === 'TOBERETURNED'">
                    <br>
                    <b-form-group>
                      <label for="incidence-desc" v-translate>To Be Returned reason</label>
                      <b-form-radio-group v-model="tobereturnedDetails" name="tobereturnedDetails" required>
                        <b-form-radio :value="{reason: 'max_retries_reached'}" class="w-100"><translate>Maximum retries reached</translate></b-form-radio>
                        <b-form-radio :value="{reason: 'other'}" class="w-100"><translate>Other</translate></b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group v-if="tobereturnedDetails.reason === 'other'">
                      <label for="incidence-desc" v-translate>To Be Returned Description</label>
                      <div class="input-group">
                        <b-form-textarea
                          id="incidence-desc"
                          v-model="newShippingStatusMeta"
                          rows="3"
                          max-rows="6"
                          :state="validateIncidenceDesc"
                          required
                        />
                        <b-form-invalid-feedback :state="validateIncidenceDesc" v-translate>
                          "Other" TOBERETURNED status requires a description for the client. Please be brief but descriptive.
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="validateIncidenceDesc" v-translate>
                          Alright.
                        </b-form-valid-feedback>
                      </div>
                    </b-form-group>
                  </div>
                  <div class="mb-3" v-if="newShippingStatus === 'CANCELED'">
                    <div class="invalid-feedback d-block" v-translate>
                      CANCELED status requires to select/write a reason below before submit the new status.
                    </div>
                    <b-form-group>
                      <label for="incidence-desc" v-translate>Cancel reason</label>
                      <b-form-radio-group v-model="cancelDetails" name="cancelDetails" required>
                        <b-form-radio v-for="(item, index) in shippingStatusReasons['CANCELED']" :value="{reason: item.name, reason_id: item.reason_id}" class="w-100" :key="index">
                          {{ item.description }}
                        </b-form-radio>
                        <b-form-radio :value="{reason: 'created_by_mistake'}" class="w-100"><translate>Created by mistake</translate></b-form-radio>
                        <b-form-radio :value="{reason: 'other'}" class="w-100"><translate>Other</translate></b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                    <b-form-group v-if="cancelDetails.reason === 'other'">
                      <label for="incidence-desc" v-translate>Incidence Description</label>
                      <div class="input-group">
                        <b-form-textarea
                          id="incidence-desc"
                          v-model="newShippingStatusMeta"
                          rows="3"
                          max-rows="6"
                          :state="validateIncidenceDesc"
                          required
                        />
                        <b-form-invalid-feedback :state="validateIncidenceDesc" v-translate>
                          "Other" CANCEL status requires a description. Please be brief but descriptive.
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="validateIncidenceDesc" v-translate>
                          Alright.
                        </b-form-valid-feedback>
                      </div>
                    </b-form-group>
                  </div>
                  <b-row class="mt-1">
                    <b-col>
                      <b-button variant="success" type="submit" v-translate>Change Status</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-tab>
              <b-tab :title="$gettext('FROM')" :disabled="collectionHas3P">
                <div class="mb-1">
                  <b-form-group v-if="!$cookies.get('bypassCountry') && warehousesSelect.length > 0">
                    <label for="filter-warehouse" v-translate>Select Origin Warehouse</label>
                    <b-form-select v-model="fromWarehouse" :options="warehousesSelect">
                      <template slot="first">
                        <option :value="null" v-translate>None</option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                  <label class="control-label" v-translate>Origin Address</label>
                  <address-autocomplete id="search-origin-address" v-if="!fromAddressAcInputCollection" @selected="setFromAddressCollection" static-items :minCharacter="4" class="mb-2" />
                  <p v-else>
                    {{fromAddressAcInputCollection}}
                    <b-button pill variant="danger" size="sm" @click="fromAddressAcInputCollection = ''; fromAddressCollection = null" style="padding: .2rem .45rem">✕</b-button>
                  </p>
                </div>
                <div class="mb-1">
                  <label class="control-label" v-translate>Origin Floor, door, etc.</label>
                   <b-form-input v-model="fromExtraCollection" type="text"></b-form-input>
                </div>
                <div class="mb-1">
                  <label class="control-label" v-translate>Origin Contact Name</label>
                   <b-form-input v-model="fromContactCollection" type="text"></b-form-input>
                </div>
                <div class="mb-1">
                  <label class="control-label" v-translate>Origin Contact Phone</label>
                   <b-form-input v-model="fromPhoneCollection" type="text"></b-form-input>
                </div>
                <div class="mb-1">
                  <label class="control-label" v-translate>Origin Contact Email</label>
                   <b-form-input v-model="fromEmailCollection" type="text"></b-form-input>
                </div>
                <div class="mb-1">
                  <label class="control-label" v-translate>Origin Instructions</label>
                   <b-form-input v-model="fromMetaCollection" type="text"></b-form-input>
                </div>
                <b-row class="mt-2">
                  <b-col>
                    <b-button variant="success" @click="bulkSetFromAddressCollection" v-translate>Change FROM data</b-button>
                    <b-button variant="danger" @click="clearFromAddressCollection" v-translate>Clear data</b-button>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab :title="$gettext('TO')" :disabled="collectionHas3P">
                <div class="mb-1">
                  <label class="control-label" v-translate>Destination Address</label>
                  <address-autocomplete id="search-origin-address" v-if="!toAddressAcInputCollection" @selected="setToAddressCollection" static-items :minCharacter="4" class="mb-2" />
                  <p v-else>
                    {{toAddressAcInputCollection}}
                    <b-button pill variant="danger" size="sm" @click="toAddressAcInputCollection = ''; toAddressCollection = null" style="padding: .2rem .45rem">✕</b-button>
                  </p>
                </div>
                <b-row class="mt-2">
                  <b-col>
                    <b-button variant="success" @click="preBulkSetToAddressCollection" v-translate>Change TO address</b-button>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab :title="$gettext('3P')" v-if="(isSuperAdmin || isAdmin || isHeadOperations) && filter.isOutsourced === 1">
                <b-row class="mt-2">
                  <b-col>
                    <b-button variant="danger" @click="cancel3POutsource" v-translate>Cancel 3P Outsourcing</b-button>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-alert>
    <b-row>
      <b-col cols="12" sm="4" lg="3">
        <b-form-checkbox inline v-model="selectAllTrigger"><translate>Select/Unselect All</translate></b-form-checkbox>
        <b-button variant="primary" size="sm" @click.stop="addSelectionToCollection" :disabled="selected.length === 0" v-translate>
          Add to Collection
        </b-button>
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" v-if="totalRows > perPage" class="mt-1" />
      </b-col>
      <b-col>
        <span v-b-tooltip.hover :title="noResults || outOfDateRange ? $gettext('At least one date range must be selected and it must be less than 90 days') : $gettext('Generate current view as a CSV Report')">
          <b-button size="sm" @click="downloadCsv()" :disabled="(isBusy || noResults || outOfDateRange)" v-translate>Generate current view as CSV</b-button>
        </span>
        <span v-b-tooltip.hover :title="noResults || outOfDateRange ? $gettext('At least one date range must be selected and it must be less than 90 days') : $gettext('Generate current view as a CSV Report')">
          <b-button size="sm" @click="downloadItemsCsv()" :disabled="(isBusy || noResults || outOfDateRange)" v-translate>Download current view as CSV w/Items</b-button>
        </span>
        <b-button size="sm" v-b-modal.modalMegaRouting :disabled="!dataIsMegaRoutable || (isBusy || noResults)" v-translate>Mega Routing</b-button>
        <b-button size="sm" v-b-modal.modalBulk3p :disabled="!dataIs3pable || (isBusy || noResults)" v-if="(isSuperAdmin || isAdmin || isHeadOperations) && universe.has3p" v-translate>3P Outsource</b-button>
      </b-col>
      <b-col cols="12" sm="3" lg="2">
        <b-form-group horizontal :label="$gettext('Per page')" :label-cols="6" class="text-right mb-0">
          <b-form-select  cols="6" :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="bg-white py-1" v-translate="{totalRows: totalRows || '-'}">
        Total items: <strong>%{totalRows}</strong>
      </b-col>
    </b-row>
    <b-table @row-selected="rowSelected" ref="shippingsTable" stacked="md" foot-clone :total-rows="totalRows" :sort-desc="sortDesc" :sort-by="sortBy" :per-page="perPage" :current-page="currentPage" :busy.sync="isBusy" :items="myProvider" :fields="fields" :api-url="this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint" select-mode="multi" selectedVariant="secondary" id="my-table" selectable>

      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong v-translate>Loading...</strong>
      </div>

      <template v-slot:cell(id)="data">
        <span v-if="!highPerformanceRequest && data.item.previous_shipping || data.item.following_shippings && data.item.following_shippings.length > 0">
          <span :id="'tooltip-roundtrip' + data.item.id" class="badge bg-info text-light">
            <font-awesome-icon icon="long-arrow-alt-right" size="1x" v-if="!data.item.previous_shipping" />
            <font-awesome-icon icon="long-arrow-alt-left" size="1x" v-else />
            <translate>Roundtrip</translate>
          </span>
          <br>
        </span>
        <span v-if="data.item.is_outsourced">
          <span :id="'tooltip-3p' + data.item.id" class="badge bg-danger text-light">
            <span v-translate="{'3pCompany': data.item.courier_company.name}">3P: %{3pCompany}</span>
          </span>
          <b-tooltip :target="'tooltip-3p' + data.item.id" custom-class="tooltip-3p">
            <div class="text-left">
              <div v-translate="{'3pId': data.item.outsourced_id}" class="text-nowrap">3P ID: <strong>%{3pId}</strong></div>
              <hr class="bg-white m-0">
              <company-card :company="data.item.courier_company" :profile-picture="false" priority-contact="operations" />
            </div>
            </b-tooltip>
          <br>
        </span>

        <a :href="'/edit/' + type + '/' + data.value">{{data.value | uuid }}</a> <a href="#" @click.prevent="copyToClipboard(data.value)" class="text-secondary" :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
        <div v-if="data.item.platform_id">
          <span class="badge" :style="'background-color: ' + stringToColour(' ' + data.item.platform_id + data.item.platform_id + data.item.platform_id + data.item.platform_id) + ';' + textContrastColor(stringToColour(' ' + data.item.platform_id + data.item.platform_id + data.item.platform_id + data.item.platform_id))">{{platforms.find(x => x.id === data.item.platform_id).name}}</span>
        </div>
        <b-button pill size="sm" @click.prevent="selectedShipping = data.value" v-b-modal.modalShippingMap style="padding: .2rem .45rem" :disabled="data.item.fields_revision === true"><font-awesome-icon icon="map-marker-alt" size="2x" style="font-size: 12px;vertical-align: middle" /></b-button>
        <b-button pill variant="warning" size="sm" @click.prevent="thread = data.item.threads.find(x => x.type === 'internal')" v-b-modal.modalShippingThread style="padding: .2rem .25rem" v-if="!highPerformanceRequest && data.item.threads.findIndex(x => x.type === 'internal') !== -1"><font-awesome-icon icon="comment" size="2x" style="font-size: 16px;vertical-align: middle" /></b-button>
        <b-tooltip :target="'tooltip-roundtrip' + data.item.id" v-if="data.item.following_shippings && data.item.following_shippings.length !== 0">
          <h6><translate>Roundtrip Shipping</translate></h6>
          <h5>
            <strong v-if="!data.item.previous_shipping" v-translate>Forth</strong>
            <span v-else>
              <router-link :to="{name: 'viewShipping', params: {'id': data.item.previous_shipping.id}}" v-translate>Forth</router-link>
              <small><small><a href="#" @click.prevent="copyToClipboard(data.item.previous_shipping.id)" class="text-secondary" :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a></small></small>
            </span>
            <font-awesome-icon icon="exchange-alt" size="1x" />
            <strong v-if="!data.item.following_shippings || data.item.following_shippings.length === 0" v-translate>Back</strong>
            <span v-else>
              <router-link :to="{name: 'viewShipping', params: {'id': data.item.following_shippings[0].id}}" v-translate>Back</router-link>
              <small><small><a href="#" @click.prevent="copyToClipboard(data.item.following_shippings[0].id)" class="text-secondary" :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a></small></small>
            </span>
          </h5>
        </b-tooltip>
      </template>

      <template v-slot:cell(company_id)="row">
        <div v-if="row.item.company_id">
          <b-badge variant="dark" v-translate>Company</b-badge><br>
          <a :href="'/edit/companies/' + row.item.company_id" target="_blank">#{{row.item.company_id}}</a> {{row.item.company.name}}
        </div>
        <div v-else>
          <b-badge variant="secondary" v-translate>Particular</b-badge><br>
          <a :href="'/edit/users/' + row.item.user_id" target="_blank">#{{row.item.user_id}}</a> {{row.item.user.name}}
        </div>
      </template>

      <template v-slot:cell(from_address)="row">
        <strong>{{row.item.from_contact}}</strong><br>
        <span v-if="row.item.from_phone"><a :href="'tel:' + row.item.from_phone">{{row.item.from_phone | phone(row.item.from_country_iso_code)}}</a><br></span>
        <span v-if="row.item.from_email">{{row.item.from_email}}</span>
        <hr class="p-0 my-1">
        <span v-if="(!row.item.fields_revision || row.item.fields_revision === false) || !row.item.fields_revision_data.from || typeof row.item.fields_revision_data.from === 'object'">
          <span
            class="shipping-address-listings"
            :class="row.item.fields_revision_data &&
              row.item.fields_revision_data.from &&
              typeof row.item.fields_revision_data.from === 'object' ? 'text-warning' : ''"
            :title="row.item.address_from ? row.item.address_from.formatted_address : 'ERROR IN SHIPPING ADDRESS'">
            <font-awesome-icon icon="map-marker-alt" size="1x" class="text-info" />
            <font-awesome-icon v-if="row.item.fields_revision_data &&
              row.item.fields_revision_data.from &&
              typeof row.item.fields_revision_data.from === 'object'" icon="exclamation-triangle" size="1x" /> {{row.item.address_from ? row.item.address_from.formatted_address : 'ERROR IN SHIPPING ADDRESS'}}</span>
        </span>
        <span v-if="row.item.fields_revision_data !== null && typeof row.item.fields_revision_data.from === 'string'">
          <span
            class="shipping-address-listings text-danger"
            :title="row.item.fields_revision_data.from"><font-awesome-icon icon="exclamation-triangle" size="1x" /> {{row.item.fields_revision_data.from}}</span>
        </span>
        <div v-if="row.item.fields_revision_data && row.item.fields_revision_data.from">
          <b-button pill size="sm" @click.prevent="shipping = row.item" v-b-modal.modalFixAddressFrom style="padding: 0.1rem 1rem;" v-translate>Review Address</b-button>
        </div>
        <span class="shipping-address-listings" style="display: block;" :title="row.item.from_meta" v-if="row.item.from_meta"><br>{{row.item.from_meta}}</span>
      </template>

      <template v-slot:cell(last_known_place.formatted_address)="row">
        <span class="shipping-address-listings" v-if="row.value" :title="row.value">
          <font-awesome-icon icon="map-marker-alt" size="1x" class="text-info" />
          {{ row.value }}
        </span>
      </template>

      <template v-slot:cell(to_address)="row">
        <strong>{{row.item.to_contact}}</strong><br>
        <span v-if="row.item.to_phone"><a :href="'tel:' + row.item.to_phone">{{row.item.to_phone | phone(row.item.to_country_iso_code)}}</a><br></span>
        <span v-if="row.item.to_email">
          <b-button pill v-if="!row.item.email || row.item.email !== true" @click="$set(row.item, 'email', true)" style="padding: .05rem .65rem; font-size: .8rem; white-space: nowrap" v-translate>View Email</b-button>
          <span v-if="row.item.email && row.item.email === true" style="white-space: nowrap">{{row.item.to_email}} <b-button pill variant="danger" @click="$set(row.item, 'email', false)" style="padding: .05rem .3rem; font-size: .8rem;white-space: nowrap">✕</b-button></span>
        </span>
        <hr class="p-0 my-1">
        <span v-if="(!row.item.fields_revision || row.item.fields_revision === false) || !row.item.fields_revision_data.to || typeof row.item.fields_revision_data.to === 'object'">
          <span
            class="shipping-address-listings"
            :class="row.item.fields_revision_data &&
              row.item.fields_revision_data.to &&
              typeof row.item.fields_revision_data.to === 'object' ? 'text-warning' : ''"
            :title="row.item.address_to ? row.item.address_to.formatted_address : $gettext('ERROR IN SHIPPING ADDRESS')">
            <font-awesome-icon icon="map-marker-alt" size="1x" class="text-info" />
            <font-awesome-icon v-if="row.item.fields_revision_data &&
              row.item.fields_revision_data.to &&
              typeof row.item.fields_revision_data.to === 'object'" icon="exclamation-triangle" size="1x" /> {{row.item.address_to ? row.item.address_to.formatted_address : $gettext('ERROR IN SHIPPING ADDRESS')}}</span>
        </span>
        <span v-if="row.item.fields_revision_data !== null && typeof row.item.fields_revision_data.to === 'string'">
          <span class="shipping-address-listings text-danger" :title="row.item.fields_revision_data.to"><font-awesome-icon icon="exclamation-triangle" size="1x" /> {{row.item.fields_revision_data.to}}</span>
        </span>
        <div  v-if="row.item.fields_revision_data && row.item.fields_revision_data.to">
          <b-button pill size="sm" @click.prevent="shipping = row.item" v-b-modal.modalFixAddressTo style="clear: both;padding: 0.1rem 1rem;" v-translate>Review Address</b-button>
        </div>
        <span class="shipping-address-listings" style="display: block;" :title="row.item.to_meta" v-if="row.item.to_meta">{{row.item.to_meta}}</span>
      </template>

      <template v-slot:cell(instructions)="row">
        <span class="shipping-address-listings" style="width: 100px; display: block;" :title="row.item.description" v-if="row.item.description">D: {{row.item.description}}<br></span>
        <span class="shipping-address-listings" style="width: 100px; display: block;" :title="row.item.instructions" v-if="row.item.instructions">I: {{row.item.instructions}}</span>
        <span class="shipping-address-listings" style="width: 100px; display: block;" :title="row.item.itemsQuantity + ' item(s)'" v-if="row.item.itemsToShow.length > 0">
          <a href="#" class="px-1" :class="row.item.itemsQuantity > 1 ? 'text-secondary' : ''" :style="row.item.itemsQuantity > 1 ? 'background: #ffc;' : ''" @click.prevent v-b-modal="'modalItems' + row.item.id" :translate-n="row.item.itemsQuantity" translate-plural="%{ itemsQuantity } items" v-translate="{itemsQuantity: row.item.itemsQuantity}">%{ itemsQuantity } item</a>
          <b-modal :id="'modalItems' + row.item.id" :ref="'modalItems' + row.item.id" :hide-footer="true">
            <div slot="modal-title" v-translate>Shipping Items</div>
            <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
            <b-table
              :items="row.item.itemsToShow"
              :fields="['description', 'quantity', 'serial_number']"
            >
              <template v-slot:cell(description)="row">
                - {{row.item.description || $gettext('No description')}}
              </template>
              <template v-slot:cell(quantity)="row">
                {{row.item.quantity || 1}} u.
              </template>
              <template v-slot:cell(serial_number)="row">
                {{row.item.serial_number}}
              </template>
            </b-table>
          </b-modal>
        </span>
      </template>

      <template v-slot:cell(scheduled_date)="row">
        <div v-if="row.item.scheduled_date">
          {{moment.utc(row.item.scheduled_date).tz($tz).format('YYYY-MM-DD')}}<br>
          {{moment.utc(row.item.scheduled_date).tz($tz).format('HH:mm:ss')}}
        </div>
        <div v-if="row.item.delivery_time_range">
          <b-badge variant="dark" :title="row.item.delivery_time_range.time_from.slice(0, -3) + ' - ' + row.item.delivery_time_range.time_to.slice(0, -3)" v-b-tooltip.hover>
            {{row.item.delivery_time_range.name}}
          </b-badge>
        </div>
      </template>

      <template v-slot:cell(status)="row">
        {{row.value}}
        <b-badge v-if="row.item.sla_date && ['WAITING', 'READY', 'CONFIRMED', 'ATPICKUPPOINT', 'INTRANSIT', 'INCIDENCE'].indexOf(row.value) !== -1"
          :variant="row.item.sla_date <= moment.utc().tz($tz).subtract(1, 'day').format('YYYY-MM-DD') ? 'danger' :
          (row.item.sla_date === moment.utc().tz($tz).format('YYYY-MM-DD') || row.item.sla_date === moment.utc().tz($tz).add(1, 'day').format('YYYY-MM-DD') ? 'success' : 'dark')"
        >
          {{row.item.sla_date <= moment.utc().tz($tz).subtract(1, 'day').format('YYYY-MM-DD') ? 'expired' :
          (row.item.sla_date === moment.utc().tz($tz).format('YYYY-MM-DD') ? 'on-time' : (row.item.sla_date === moment.utc().tz($tz).add(1, 'day').format('YYYY-MM-DD') ? 'tomorrow' : 'future'))}}
        </b-badge>
        <span class="text-warning" v-if="row.item.fields_revision && row.item.fields_revision_data.budget_id">
          <font-awesome-icon icon="exclamation-triangle" size="1x" :id="'tooltip-fields-revision-' + row.item.id" />
          <b-tooltip :target="'tooltip-fields-revision-' + row.item.id">
            {{row.item.fields_revision_data.budget_id}}
          </b-tooltip>
        </span>
      </template>

      <template v-slot:cell(updated_at)="row">
        {{moment.utc(row.item.updated_at).tz($tz).format('YYYY-MM-DD')}}<br>
        {{moment.utc(row.item.updated_at).tz($tz).format('HH:mm:ss')}}
      </template>

      <template v-slot:cell(created_at)="row">
        {{moment.utc(row.item.created_at).tz($tz).format('YYYY-MM-DD')}}<br>
        {{moment.utc(row.item.created_at).tz($tz).format('HH:mm:ss')}}
      </template>

      <template v-slot:cell(courier)="row">
        <div v-if="row.item.courier">
          <user-card :user='row.item.courier' :profile-picture="false" :with-titles="false" :vehicle-types-prop="vehicleTypes" />
        </div>
      </template>

      <template v-slot:cell(courier_commission)="row">
        <span :class="parseFloat(row.item.price) <= parseFloat(row.item.courier_commission) &&  parseFloat(row.item.courier_commission) !== 0? 'bg-danger text-white p-1' : ''" v-if="isSuperAdmin">{{row.item.courier_commission}}</span>
        <span v-else>{{row.item.courier_commission}}</span>
      </template>

      <template v-slot:cell(size_id)="row">
        {{shippingSizes.find(x => x.id === row.item.size_id) ? shippingSizes.find(x => x.id === row.item.size_id).name : ''}}
      </template>

      <template v-slot:cell(shipping_type_id)="row">
        {{shippingTypes.find(x => x.id === row.item.shipping_type_id) ? shippingTypes.find(x => x.id === row.item.shipping_type_id).name : ''}}
        <div v-if="!highPerformanceRequest && row.item.tags && row.item.tags.length > 0">
          <span v-for="(item, index) in row.item.tags" :key="index">
            <b-badge pill variant="danger">{{ item.name }}</b-badge>&nbsp;
          </span>
        </div>
      </template>

      <template v-slot:cell(actions)="row">
        <span v-if="!row.item.is_outsourced">
          <b-button pill size="sm" @click.stop="row.toggleDetails" style="padding: .5rem">
            <font-awesome-icon v-if="row.detailsShowing" :icon="['far', 'eye-slash']" size="2x" style="font-size: 16px;vertical-align: middle" />
            <font-awesome-icon v-else :icon="['far', 'eye']" size="2x" style="font-size: 16px;vertical-align: middle" />
          </b-button>
          <b-button pill style="padding: .5rem .6rem;font-weight:bold;" variant="primary" size="sm" @click.stop="addToRoutifier(row.item);" v-if="(!row.item.fields_revision || row.item.fields_revision === false) && shippingCollection.indexOf(row.item.id) === -1">
            C+
          </b-button>
          <b-link style="padding: .5rem;font-weight:bold;" class="btn bg-warning rounded-pill" target="_blank" size="sm" @click.stop :to="{name: 'viewTour', params: {id: row.item.tour_id}}" v-if="row.item.tour_id" :title="$gettext('Open containing Tour')">
            <font-awesome-icon :icon="['fa', 'map-marked-alt']" size="2x" style="font-size: 18px;vertical-align: middle" />
          </b-link>
        </span>
        <span v-if="(row.item.status === 'DRAFT' || row.item.status === 'READY' || row.item.status === 'READYATSTORE') && !row.item.fields_revision">
          <b-button pill variant="danger" size="sm"  style="padding: .5rem .7rem" @click.stop.prevent="getShippingLabel(row.item)" title="Get Shipping PDF label"><font-awesome-icon icon="file-pdf" size="2x" style="font-size: 16px;vertical-align: middle" /></b-button>
        </span>
      </template>

      <template v-slot:row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key" v-if="value && value.length !== 0 && value !== 'undefined' && value !== null">{{ key }}: <span v-html="key.indexOf('phone') === -1 ? isJson(value) : value.toString()"></span></li>
          </ul>
        </b-card>
      </template>

    </b-table>
    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" v-if="totalRows > perPage" class="my-0" />

    <b-modal id="modalCollectionMap" size="xl" ref="modalCollectionMap" @shown="showPairs = true; addMarkers()" @hide="showPairs = false" :hide-header="true" :hide-footer="true">
      <div slot="modal-title" v-translate>Collection Map</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
       <b-form-checkbox v-model="showPairs">
        <translate>Show Pairs</translate>
      </b-form-checkbox>
      <leaflet-map ref="fullMap" style="height:80vh" :fitAlways="true" :geolocate="false" polygonable @itemRemoved="removeFromCollectionById" @itemsRemoved="removeFromCollectionByIds" />
    </b-modal>

    <b-modal id="modalClustersMap" size="xl" ref="modalClustersMap" @shown="showPairs = true; addMarkers()" @hide="showPairs = false; clusteringMethodReady = false; routingMethod = null" :hide-header="true" :hide-footer="true">
      <div slot="modal-title" v-translate>Collection Map</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <div v-if="!clusteringMethodReady">
        <b-row>
          <b-col>
            <b-form-select v-model="clusteringMethod" :options="clusteringMethodSelectComputed" class="mb-3"></b-form-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <!-- max vehicle qty -->
            <div v-show="clusteringMethod === 'cluster_vehicle_quantity'">
              <div class="mb-1">
                <label class="control-label" v-translate>Max Courier Qty.</label>
                <b-form-input type="number" v-model="routifierCourierCount" :formatter="(value) => parseInt(value)" />
              </div>
            </div>
            <!-- vehicle max capacity -->
            <div v-show="clusteringMethod === 'cluster_vehicle_aprox_capacity'">
              <div class="mb-1">
                <label class="control-label" v-translate>Vehicle Max Capacity</label>
                <b-form-select v-model="vehicleMaxCapacity">
                  <option :value="null" v-translate>Please select an option</option>
                  <option :value="1">1</option>
                  <option :value="2">2</option>
                  <option :value="3">3</option>
                  <option :value="4">4</option>
                  <option :value="5">5</option>
                  <option :value="10">10</option>
                  <option :value="15">15</option>
                  <option :value="20">20</option>
                  <option :value="25">25</option>
                  <option :value="30">30</option>
                  <option :value="40">40</option>
                  <option :value="50">50</option>
                </b-form-select>
              </div>
            </div>
            <!-- route closest by vehicle max items capacity -->
            <div v-show="clusteringMethod === 'cluster_vehicle_capacity'">
              <div class="mb-1">
                <label class="control-label" v-translate>Vehicle Max Capacity</label>
                <b-form-select v-model="vehicleMaxCapacity">
                  <option :value="null" v-translate>Please select an option</option>
                  <option :value="1">1</option>
                  <option :value="2">2</option>
                  <option :value="3">3</option>
                  <option :value="4">4</option>
                  <option :value="5">5</option>
                  <option :value="10">10</option>
                  <option :value="15">15</option>
                  <option :value="20">20</option>
                  <option :value="25">25</option>
                  <option :value="30">30</option>
                  <option :value="40">40</option>
                  <option :value="50">50</option>
                </b-form-select>
              </div>
            </div>
            <!-- route closest by vehicle max weight capacity -->
            <div v-show="clusteringMethod === 'cluster_vehicle_weight'">
              <div class="mb-1">
                <label class="control-label" v-translate>Vehicle Max Capacity (in KG.)</label>
                <b-form-input v-model="vehicleMaxCapacityWeight"
                  type="number"
                  :placeholder="$gettext('Max weight in KG.')"
                ></b-form-input>
              </div>
            </div>
          </b-col>
          <b-col v-show="clusteringMethodSelect.find(x => x.value === clusteringMethod).subOptions">
            <label class="control-label" v-translate>Routing Method</label>
            <b-form-select v-model="routingMethod" :options="clusteringMethodSelect.find(x => x.value === clusteringMethod).subOptions" class="mb-3">
              <template #first>
                <option :value="null" v-translate>None</option>
              </template>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button @click="clusteringMethodReady = true; sendToSuggest()" variant="primary" v-translate>
              Suggest Clusters!
            </b-button>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <leaflet-map ref="fullMap" style="height:80vh" :fitAlways="true" :geolocate="false" @itemRemoved="removeFromCollectionById" @clusterSelected="selectCluster" @itemsRemoved="removeFromCollectionByIds" @moveToCluster="moveToCluster">
          <template #controls-bottomleft>
            <div style="width: 200px;" v-if="!$cookies.get('bypassCountry')">
              <b-card>
                <b-form-checkbox v-model="showAreas" :value="true" :unchecked-value="false">
                  <translate>Routing Zones</translate>
                </b-form-checkbox>
                <b-form-checkbox v-model="showAreasTooltips" :value="true" :unchecked-value="false" :disabled="!showAreas">
                  <translate>Routing Zones' Codes</translate>
                </b-form-checkbox>
              </b-card>
            </div>
          </template>
        </leaflet-map>
        <b-card style="position: absolute; top: 167px; right: 10px; width: 200px; z-index: 1000; bottom: 10px;">
          <b-card-text style="height: 100%; overflow: auto">
            <b-form-checkbox-group id="clusters-group" v-model="selectedClusters" class="mb-3">
              <b-form-checkbox :value="index" v-for="(cluster, index) in clusters" :key="index">
                <span :style="'width: 12px; height: 12px; display: inline-block; background-color: #' + clusterColors[index]"></span>
                <span :id="'tooltip-target-' + index" v-translate="{n: index + 1}">Cluster %{n}</span>
                <small>({{ cluster.filter(x => x.type === 'dropoff').length >= cluster.filter(x => x.type === 'pickup').length ? cluster.filter(x => x.type === 'dropoff').length : cluster.filter(x => x.type === 'pickup').length }})</small>
                <b-tooltip :target="'tooltip-target-' + index" triggers="hover">
                  <div v-for="(item, index) in clusterShippingSizes(cluster)" :key="index">
                    <b-badge class="mr-1" variant="dark">{{index}}</b-badge>
                    <span
                      v-translate="{count: item}"
                      :translate-n="item"
                      translate-plural="%{ count } shippings"
                    >%{ count } shipping
                    </span>
                  </div>
                  <p class="m-0 mt-2" v-translate="{weight: clusterShippingsWeight(cluster)}">%{weight} KG.</p>
                </b-tooltip>
                <b-button size="sm" pill variant="link" @click.prevent="previewTour(cluster, index)" style="padding: 0 .2rem" :title="$gettext('Preview Tour')">
                  <font-awesome-icon :icon="['far', 'eye']" size="2x" style="font-size: 16px;vertical-align: middle;" />
                </b-button>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-card-text>
          <template #footer>
            <div class="text-center">
              <b-button size="sm" variant="warning" @click.prevent="openInNewList" :disabled="selectedClusters.length < 1" class="mb-2" v-translate>
                Open in new List
              </b-button>
              <b-button size="sm" variant="secondary" @click.prevent="mergeSelectedClusters" :disabled="selectedClusters.length <= 1" class="mb-2" v-translate>
                Merge selected
              </b-button>
              <b-button size="sm" variant="success" @click.prevent="sendClustersToRoutifier" :disabled="selectedClusters.length < 1" v-translate>
                Send to Routifier
              </b-button>
            </div>
          </template>
        </b-card>
      </div>
    </b-modal>

    <b-modal id="modalCsvImport" size="lg" ref="modalCsvImport" :hide-footer="true">
      <div slot="modal-title" v-translate>CSV Bulk Import</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <csv-import @success="csvUploaded" @cancel="$refs.modalCsvImport.hide()" />
    </b-modal>

    <b-modal id="modalFixAddressFrom" ref="modalFixAddressFrom" :hide-footer="true">
      <div slot="modal-title" v-translate>Review FROM Address</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <fix-addresses-form :theShipping="shipping" type="from" @success="addressFixed('modalFixAddressFrom')" @cancel="closeModal('modalFixAddressFrom')" />
    </b-modal>

    <b-modal id="modalFixAddressTo" ref="modalFixAddressTo" :hide-footer="true">
      <div slot="modal-title" v-translate>Review TO Address</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <fix-addresses-form :theShipping="shipping" type="to" @success="addressFixed('modalFixAddressTo')" @cancel="closeModal('modalFixAddressTo')" />
    </b-modal>
    <b-modal id="modalShippingMap" size="xl" ref="modalShippingMap" :hide-header="true" :hide-footer="true" @hide="killMap(); selectedShipping = null">
      <leaflet-map ref="shippingMap" style="height:80vh" :fit-once="true" :geolocate="false" @ready="initMap(selectedShipping)" />
    </b-modal>

    <b-modal size="lg" id="modalShippingThread" ref="modalShippingThread" @hidden="thread = {}" hide-footer>
      <div slot="modal-title" v-translate>Shipping Message Thread</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <shipping-message-threads :the-thread="thread" v-if="thread" no-subject />
    </b-modal>

    <b-modal id="modalPreviewTour" size="xl" ref="modalPreviewTour" @shown="addMarkersPreviewTour" @hide="selectedClusters = []; $refs.previewTourMap.markers = []; $refs.previewTourMap.polyLines = []" :hide-header="true" :hide-footer="true">
      <div slot="modal-title" v-translate>Tour Preview</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <leaflet-map ref="previewTourMap" style="height:80vh" :fitAlways="true" :geolocate="false" />
      <div class="mt-2 d-flex">
        <div class="float-left text-right w-50 pr-1 align-self-center">
          <b-button size="sm" variant="secondary" @click.prevent="sendClustersToRoutifier" v-translate>
            Confirm Tour
          </b-button>
        </div>
        <div class="float-right text-left w-50 pl-1 align-self-center">
          <small class="text-nowrap d-block" v-translate="{etc: previewTourEtc + ' hs'}">
            ETC: <strong>%{etc}</strong>
          </small>
          <small class="text-nowrap d-block" v-translate="{fdt: previewTourFinishTime}">
            Estimated FDT: <strong>%{fdt}</strong>
          </small>
        </div>
      </div>
    </b-modal>

    <b-modal size="xl" id="modalMegaRouting" ref="modalMegaRouting" hide-footer>
      <div slot="modal-title" v-translate>Mega Routing</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <shipping-mega-routing :filters="csvUrl.params" />
    </b-modal>

    <b-modal size="xl" id="modalBulk3p" ref="modalBulk3p" hide-footer>
      <div slot="modal-title" v-translate>Bulk 3P Outsource</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <shipping-bulk-3p :filters="csvUrl.params" />
    </b-modal>

    <div class="simplert d-block" v-if="isLoading">
      <spinner v-if="isLoading" />
    </div>
  </b-container>
</template>

<script>
function getCookie(name) {
  let v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
function initialQuickFilters() {
  return {
    statuses: [],
    types: [],
    sizes: [],
    scheduleds: 'null',
    scheduledsToday: 'null',
    cutTime: false,
    workingOnSat: false,
    workingOnSun: false,
    shippingId: '',
    destinationContactName: '',
    nearOrigin: null,
    originAddress: '',
    destinationAddress: '',
    destinationArea: [],
    destinationContactEmail: '',
    externalCode: '',
    pickupId: '',
    tag: [],
    company: [],
    courier: [],
    client: [],
    withoutTour: 'indeterminate',
    forReview: false,
    createdDateRangeActive: 0,
    updatedDateRangeActive: 1,
    readyWithIncidence: null,
    needUrgentAction: false,
    roundtrips: false,
    roundtripLegs: 'all',
    warehouse: getCookie('warehouse') || null,
    deliveryTimeRange: null,
    deliveryTimeRangeNot: false,
    sla: [],
    isOutsourced: false,
    courierCompany: []
  }
}
import AddressMixins from '@/mixins/address.mixin.js'
import ShippingsMixins from '@/mixins/shippings.mixin'
import AddressAutocomplete from '@/components/autocompletes/AddressAutocomplete'
import ListingFilter from '@/components/ListingFilter'
import DateRangePicker from 'vue2-daterange-picker'
import CsvImport from '@/components/CsvImport'
import UserCard from '@/components/UserCard'
import PlacePicker from '@/components/PlacePicker'
import LeafletMap from '@/components/LeafletMap'
import ShippingMessageThreads from '@/components/ShippingMessageThreads'
import CirclePicker from '@/components/CirclePicker'
import FixAddressesForm from '@/components/FixAddressesForm'
import TagAutocomplete from '@/components/autocompletes/TagAutocomplete'
import CompanyAutocomplete from '@/components/autocompletes/CompanyAutocomplete'
import UserAutocomplete from '@/components/autocompletes/UserAutocomplete'
import Spinner from '@/components/Spinner'
import ShippingMegaRouting from '@/components/ShippingMegaRouting'
import ShippingBulk3p from '@/components/ShippingBulk3p'

export default {
  name: 'ApiList',
  components: {
    AddressAutocomplete,
    ListingFilter,
    DateRangePicker,
    CsvImport,
    UserCard,
    PlacePicker,
    LeafletMap,
    ShippingMessageThreads,
    CirclePicker,
    FixAddressesForm,
    TagAutocomplete,
    CompanyAutocomplete,
    UserAutocomplete,
    Spinner,
    ShippingMegaRouting,
    ShippingBulk3p
  },
  props: {
    type: {
      type: String,
      default: 'shippings'
    },
    title: {
      type: String
    },
    // fields: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   }
    // },
    // filterFields: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   }
    // },
    // exclude: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   }
    // },
    preFilters: {
      type: Array,
      default: () => {
        return []
      }
    },
    prePerPage: {
      type: Number,
      default: 25
    }
  },
  data () {
    return {
      country: window.country,
      fields: [],
      filterFields: this.$appConfig.models['shippings'].filters,
      exclude: this.$appConfig.models['shippings'].exclude,
      includes: this.$appConfig.models['shippings'].includes || [],
      isBusy: false,
      currentPage: 1,
      perPage: this.prePerPage,
      totalRows: null,
      pageOptions: [ 10, 25, 50, 100 ],
      sortBy: 'updated_at',
      sortDesc: true,
      sortDirection: 'desc',
      tabIndex: 0,
      filters: [],
      shippingCollection: [],
      shippingCollectionObject: [],
      shippingViewObject: [],
      routifierCourierCount: 1,
      routifierCouriers: [],
      searchQuery: '',
      selectedSearchItem: null,
      acOptions: {
        debounce: 500,
        placeholder: this.$gettext('Courier Name or Email'),
        inputClass: 'form-control'
      },
      minCharacter: 2,
      fromAddressAcInput: '',
      toAddressAcInput: '',
      toAddressRawInput: false,
      fromAddressCollection: null,
      fromAddressAcInputCollection: '',
      fromContactCollection: null,
      fromExtraCollection: null,
      fromMetaCollection: null,
      fromEmailCollection: null,
      fromPhoneCollection: null,
      toAddressCollection: null,
      toAddressAcInputCollection: '',
      start_location: {},
      selectAllTrigger: false,
      selected: [],
      savedQuickSearches: [],
      advancedFilters: [],
      filter: initialQuickFilters(),
      quickFilters: {},
      statuses: [
        'DRAFT',
        'READYATSTORE',
        'READY',
        'WAITING',
        'BLOCKED',
        'CONFIRMED',
        'ATPICKUPPOINT',
        'PICKEDUP',
        'INTRANSIT',
        'INCIDENCE',
        'TOBERETURNED',
        'DELIVERED',
        'CANCELED',
        'RETURNED'
      ],
      companyAcOptions: {
        debounce: 500,
        placeholder: this.$gettext('Company Name, Business Name or TIN'),
        inputClass: 'form-control'
      },
      searchCompanyQuery: '',
      searchCourierQuery: '',
      searchClientQuery: '',
      clientAcOptions: {
        debounce: 500,
        placeholder: this.$gettext('Client Name or Email'),
        inputClass: 'form-control'
      },
      searchTagQuery: '',
      tagAcOptions: {
        debounce: 500,
        placeholder: this.$gettext('Tag name'),
        inputClass: 'form-control'
      },
      createdDateRange: { // used for v-model prop
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      },
      updatedDateRange: { // used for v-model prop
        startDate: this.moment().subtract(7, 'days').toDate(),
        endDate: this.moment().toDate()
      },
      opens: 'right', //  which way the picker opens, default "center", can be "left"/"right"
      locale1: {},
      locale2: {},
      ranges: { //  default value for ranges object (if you set this to false ranges will no be rendered)
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('This month')]: [this.moment().startOf('month').toDate(), this.moment().endOf('month').toDate()],
        [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week').toDate(), this.moment().subtract(1, 'week').endOf('week').toDate()],
        [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month').toDate(), this.moment().subtract(1, 'month').endOf('month').toDate()]
      },
      datepickerLocalized: false,
      statusesMap: {
        DRAFT: ['DRAFT', 'READYATSTORE', 'READY', 'CANCELED', 'INCIDENCE'],
        READYATSTORE: ['DRAFT', 'READYATSTORE', 'READY', 'CANCELED'],
        READY: ['DRAFT', 'READY', 'CANCELED', 'WAITING', 'CONFIRMED', 'INCIDENCE'],
        WAITING: ['DRAFT', 'READY', 'WAITING', 'CANCELED', 'CONFIRMED'],
        BLOCKED: ['READY'],
        CONFIRMED: ['READY', 'CANCELED', 'ATPICKUPPOINT', 'INCIDENCE', 'PICKEDUP', 'INTRANSIT'],
        ATPICKUPPOINT: ['ATPICKUPPOINT', 'INCIDENCE', 'PICKEDUP', 'INTRANSIT', 'CANCELED'],
        PICKEDUP: ['INTRANSIT', 'CANCELED'],
        INTRANSIT: ['DELIVERED', 'INCIDENCE', 'CANCELED'],
        INCIDENCE: ['READY', 'WAITING', 'CONFIRMED', 'INTRANSIT', 'DELIVERED', 'TOBERETURNED', 'CANCELED'],
        TOBERETURNED: ['READY', 'RETURNED', 'CANCELED'],
        DELIVERED: [],
        CANCELED: [],
        RETURNED: []
      },
      newShippingStatus: null,
      reScheduledAt: null,
      statusCourier: {},
      markers: [],
      pairs: [],
      showPairs: false,
      incidenceDetails: {},
      cancelDetails: {},
      tobereturnedStatusReasons: [],
      tobereturnedDetails: {},
      newShippingStatusMeta: null,
      csvData: [],
      csvUrl: {},
      csvItemsUrl: {},
      shipping: {},
      backofficePreferences: {},
      backofficePreferencesActive: true,
      validFrom: false,
      validTo: false,
      intervalShippingMap: null,
      selectedShipping: null,
      markersShipping: [],
      fitted: false,
      clusteringMethodReady: false,
      clusteringMethodSelect: [
        {
          text: this.$gettext('Best Tours By Couriers Qty.'),
          value: 'cluster_vehicle_quantity'
        },
        {
          text: this.$gettext('By Vehicle ITEMS Capacity (APROX)'),
          value: 'cluster_vehicle_aprox_capacity',
          subOptions: [
            {
              text: 'Closest',
              value: 'closest'
            },
            {
              text: 'Round',
              value: 'round'
            },
            {
              text: 'Radial',
              value: 'radial'
            },
            {
              text: 'Anular',
              value: 'anular'
            },
            // {
            //   text: 'Cluster',
            //   value: 'cluster'
            // },
            {
              text: 'Farthest',
              value: 'farthest'
            }
          ]
        },
        {
          text: this.$gettext('By Vehicle ITEMS Capacity (EXACT)'),
          value: 'cluster_vehicle_capacity',
          subOptions: [
            {
              text: 'Closest',
              value: 'closest'
            },
            {
              text: 'Round',
              value: 'round'
            },
            {
              text: 'Radial',
              value: 'radial'
            },
            {
              text: 'Anular',
              value: 'anular'
            },
            // {
            //   text: 'Cluster',
            //   value: 'cluster'
            // },
            {
              text: 'Farthest',
              value: 'farthest'
            }
          ]
        },
        {
          text: this.$gettext('By Vehicle WEIGHT Capacity (EXACT)'),
          value: 'cluster_vehicle_weight',
          subOptions: [
            {
              text: 'Closest',
              value: 'closest'
            },
            {
              text: 'Round',
              value: 'round'
            },
            {
              text: 'Radial',
              value: 'radial'
            },
            {
              text: 'Anular',
              value: 'anular'
            },
            // {
            //   text: 'Cluster',
            //   value: 'cluster'
            // },
            {
              text: 'Farthest',
              value: 'farthest'
            }
          ]
        },
        {
          text: this.$gettext('Best Tours By Geographical Zones'),
          value: 'cluster_geozone',
          countrize: true
        }
      ],
      clusteringMethod: 'cluster_vehicle_quantity',
      routingMethod: null,
      clusters: [],
      clusterColors: [
        'FF6C87',
        '8A89E1',
        'C5E662',
        '4DA2FF',
        'FFB54D',
        'F03A47',
        '1B998B',
        '6d05d6',
        '000000',
        'C5D86D',
        '712F79',
        'F7996E',
        '48639C',
        'CA895F',
        '4E3822',
        '06BEE1',
        'ff6600',
        '319200',
        '653300',
        '884cff'
      ],
      selectedClusters: [],
      vehicleMaxCapacity: 5,
      vehicleMaxCapacityWeight: null,
      thread: {},
      previewTourEtc: null,
      previewTourFinishTime: null,
      previewTourPolyLines: [],
      previewTourMarkers: [],
      isLoading: false,
      countryAreas: [],
      showAreas: false,
      showAreasTooltips: false,
      allTypesSelected: false,
      indeterminateTypesSelected: false,
      highPerformanceRequest: false,
      fromWarehouse: null
    }
  },
  watch: {
    fromWarehouse(val) {
      if (val) {
        const wh = this.warehouses.find(x => x.place_id === val)

        if (wh.id) {
          this.fromAddressCollection = wh.place.id
          this.fromAddressAcInputCollection = wh.place.formatted_address
        } else {
          this.fromWarehouse = null
        }
      } else {
        this.fromAddressCollection = null
        this.fromAddressAcInputCollection = ''
      }
    },
    type: function (val) {
      console.log(this.type)
      console.log(val)
      this.resetData()
      this.$refs.listingFilters.resetData()
      this.fields = this.$appConfig.models[this.type].fields
      this.filterFields = this.$appConfig.models[this.type].filters
      this.exclude = this.$appConfig.models[this.type].exclude
      this.fields.push({ key: 'actions', label: this.$gettext('Actions') })
      let that = this
      this.fields = this.fields.filter(function (obj) {
        if (that.exclude) {
          return that.exclude.indexOf(obj.key) === -1
        } else {
          return true
        }
      })
      this.refreshTable()
    },
    exclude: function (val) {
      return this.$appConfig.models[this.type].exclude
    },
    selectAllTrigger: function (val) {
      if (val === true) {
        this.selectAll()
      } else {
        this.unselectAll()
      }
    },
    showPairs(val) {
      if (val === true) {
        this.addPair()
      } else {
        this.addMarker()
      }
    },
    highPerformanceRequest(val) {
      if (val) {
        this.pageOptions = [ 10, 25, 50, 100, 500 ]
      } else {
        this.pageOptions = [ 10, 25, 50, 100 ]
        if (this.perPage === 500) {
          this.perPage = 25
        }
      }
    },
    'filter.statuses': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['statuses'] = [ 'status', 'in', val ]
        } else {
          this.quickFilters['statuses'] = []
        }
        if (val.indexOf('DRAFT') === -1 && val.indexOf('READY') === -1 && val.indexOf('WAITING') === -1) {
          this.filter.withoutTour = 'indeterminate'
          this.filter.scheduleds = 'null'
        }
        if (val.indexOf('DRAFT') === -1) {
          this.filter.forReview = false
        }
      },
      deep: true
    },
    'filter.types': {
      handler (val) {
        if (val.length > 0) {
          if (val.length === this.shippingTypesSelect.length) {
            this.indeterminateTypesSelected = false
            this.allTypesSelected = true
          } else {
            this.indeterminateTypesSelected = true
            this.allTypesSelected = false
          }
          this.quickFilters['types'] = [ 'shipping_type_id', 'in', val ]
        } else {
          this.quickFilters['types'] = []
          this.indeterminateTypesSelected = false
          this.allTypesSelected = false
        }
      },
      deep: true
    },
    'filter.sizes': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['sizes'] = [ 'size_id', 'in', val ]
        } else {
          this.quickFilters['sizes'] = []
        }
      },
      deep: true
    },
    'filter.scheduleds': {
      handler (val) {
        if (val === 'indeterminate' || val === 'null') {
          // view HACK on this.myProvider()
          this.sortBy = 'updated_at'
          this.sortDesc = true
          this.quickFilters['scheduleds'] = []
        } else {
          // another HACK :(
          this.filter.scheduleds = 'false'
          this.sortBy = 'scheduled_date'
          this.sortDesc = false
          this.quickFilters['scheduleds'] = [ 'scheduled_date', 'gt', this.moment().add(1, 'day').startOf('day').utc().format('YYYY-MM-DD HH:mm:ss') ]
        }
      },
      deep: true
    },
    'filter.scheduledsToday': {
      handler (val) {
        if (val === 'indeterminate' || val === 'null') {
          // view HACK on this.myProvider()
          this.sortBy = 'updated_at'
          this.sortDesc = true
          this.quickFilters['scheduledsToday'] = []
        } else {
          // another HACK :(
          this.filter.scheduleds = 'false'
          this.sortBy = 'scheduled_date'
          this.sortDesc = false
          this.quickFilters['scheduledsToday'] = [ 'scheduled_date', 'lt', this.moment().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss') ]
        }
      },
      deep: true
    },
    'filter.cutTime': {
      handler (val) {
        if (val === 1) {
          this.quickFilters['cutTime'] = [ 'cutTime', 'lte', 1 ]
        } else {
          this.quickFilters['cutTime'] = []
        }
      },
      deep: true
    },
    'filter.workingOnSat': {
      handler (val) {
        if (val === 1) {
          this.quickFilters['workingOnSat'] = [ 'company.cut_time_saturday', 'eq', null, 'true' ]
        } else {
          this.quickFilters['workingOnSat'] = []
        }
      },
      deep: true
    },
    'filter.workingOnSun': {
      handler (val) {
        if (val === 1) {
          this.quickFilters['workingOnSat'] = [ 'company.cut_time_sunday', 'eq', null, 'true' ]
        } else {
          this.quickFilters['workingOnSat'] = []
        }
      },
      deep: true
    },
    'filter.shippingId': {
      handler (val) {
        if (val.length > 0) {
          let ids
          if (val.indexOf('\n') === -1 && val.indexOf(',') === -1 && Array.isArray(val) === false) {
            this.quickFilters['shippingId'] = [ (val.length <= 8) ? 'short_id' : 'id', 'eq', val ]
          } else if (val.indexOf('\n') !== -1) {
            ids = val.split('\n')
            this.quickFilters['shippingId'] = [ 'id', 'in', ids ]
          } else if (Array.isArray(val)) {
            this.quickFilters['shippingId'] = [ 'id', 'in', val ]
          } else {
            let ids = val.split(',')
            this.quickFilters['shippingId'] = [ 'id', 'in', ids ]
          }
        } else {
          this.quickFilters['shippingId'] = []
        }
      },
      deep: true
    },
    'filter.destinationContactName': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['destinationContactName'] = [ 'to_contact', 'ct', val ]
        } else {
          this.quickFilters['destinationContactName'] = []
        }
      },
      deep: true
    },
    'filter.destinationContactEmail': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['destinationContactEmail'] = [ 'to_email', 'eq', val ]
        } else {
          this.quickFilters['destinationContactEmail'] = []
        }
      },
      deep: true
    },
    'filter.originAddress': {
      handler (val) {
        if (val > 0) {
          this.quickFilters['originAddress'] = {
            or: true,
            filters: [
              [ 'from_place_id', 'eq', val ],
              [ 'last_known_place_id', 'eq', val ]
            ]
          }
        } else {
          this.quickFilters['originAddress'] = []
        }
      },
      deep: true
    },
    'filter.nearOrigin': {
      handler (val) {
        if (val) {
          this.quickFilters['nearOrigin'] = ['address_from', 'near', val]
        } else {
          this.quickFilters['nearOrigin'] = []
        }
      },
      deep: true
    },
    'filter.destinationAddress': {
      handler (val) {
        if (val) {
          if (this.toAddressRawInput) {
            this.quickFilters['destinationAddress'] = [ 'address_to.formatted_address', 'ct', val ]
          } else {
            this.quickFilters['destinationAddress'] = [ 'to_place_id', 'eq', val ]
          }
        } else {
          this.quickFilters['destinationAddress'] = []
        }
      },
      deep: true
    },
    'filter.destinationArea': {
      handler (val) {
        if (val?.length > 0) {
          this.quickFilters['destinationArea'] = ['to_area_id', 'in', val]
        } else {
          this.quickFilters['destinationArea'] = []
        }
      },
      deep: true
    },
    'filter.externalCode': {
      handler (val) {
        if (val.length > 0) {
          let ids = val
          let operator = 'in'
          if (val.indexOf('\n') === -1 && val.indexOf(',') === -1 && Array.isArray(val) === false) {
            operator = 'eq'
          } else if (val.indexOf('\n') !== -1) {
            ids = val.split('\n').filter(Boolean)
          } else if (Array.isArray(val)) {
            ids = val.filter(Boolean)
          } else {
            ids = val.split(',').filter(Boolean)
          }

          this.quickFilters['externalCode'] = {or: true, filters: [[ 'external_code', operator, ids ], [ 'external_order_id', operator, ids ]]}
        } else {
          this.quickFilters['externalCode'] = []
        }
      },
      deep: true
    },
    'filter.pickupId': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['pickupId'] = [ 'pickup_shipping_id', 'eq', val.trim() ]
        } else {
          this.quickFilters['pickupId'] = []
        }
      },
      deep: true
    },
    'filter.tag': {
      handler (val) {
        if (val.length > 0) {
          let tags = val.map(function (item) {
            return item.name
          })
          this.quickFilters['tag'] = [[ 'tags.name', 'in', tags ], tags]
        } else {
          this.quickFilters['tag'] = []
        }
      },
      deep: true
    },
    'filter.withoutTour': {
      handler (val) {
        if (val === 'indeterminate') {
          this.quickFilters['withoutTour'] = []
        } else if (val === 'null') {
          this.quickFilters['withoutTour'] = [ 'tour_id', 'eq', 'null' ]
        } else {
          this.quickFilters['withoutTour'] = [ 'tour_id', 'eq', 'null', true ]
        }
      },
      deep: true
    },
    'filter.company': {
      handler (val) {
        if (val.length > 0) {
          let companies = val.map(function (item) {
            return item.id
          })
          let companyNames = val.map(function (item) {
            return item.name
          })
          this.quickFilters['company'] = [[ 'company_id', 'in', companies ], companyNames]
        } else {
          this.quickFilters['company'] = []
        }
      },
      deep: true
    },
    'filter.courier': {
      handler (val) {
        if (val.length > 0) {
          let couriers = val.map(function (item) {
            return item.id
          })
          let courierEmails = val.map(function (item) {
            return item.email
          })
          this.quickFilters['courier'] = [[ 'courier_id', 'in', couriers ], courierEmails]
        } else {
          this.quickFilters['courier'] = []
        }
      },
      deep: true
    },
    'filter.client': {
      handler (val) {
        if (val.length > 0) {
          let clients = val.map(function (item) {
            return item.id
          })
          let clientEmails = val.map(function (item) {
            return item.email
          })
          this.quickFilters['client'] = [[ 'user_id', 'in', clients ], clientEmails]
        } else {
          this.quickFilters['client'] = []
        }
      },
      deep: true
    },
    'filter.forReview': {
      handler (val) {
        if (val === 1) {
          this.quickFilters['forReview'] = [ 'fields_revision', 'eq', 1 ]
        } else {
          this.quickFilters['forReview'] = []
        }
      },
      deep: true
    },
    'filter.readyWithIncidence': {
      handler (val) {
        if (val !== null) {
          this.filter.statuses = []
          this.quickFilters['readyWithIncidence'] = [ 'ready_with_incidence', 'eq', val ]
        } else {
          this.filter.withoutTour = 'indeterminate'
          this.quickFilters['readyWithIncidence'] = []
        }
      },
      deep: true
    },
    'filter.needUrgentAction': {
      handler (val) {
        if (val) {
          this.filter.statuses = []
          this.sortBy = 'created_at'
          this.sortDesc = false
          this.quickFilters['needUrgentAction'] = [ 'first_ready_date', 'eq', 'NULL', true ]
          this.quickFilters['needUrgentActionStatuses'] = [ 'status', 'eq', 'DRAFT' ]
          this.quickFilters['forReview'] = [ 'fields_revision', 'eq', 1 ]
        } else {
          this.sortBy = 'updated_at'
          this.sortDesc = true
          this.quickFilters['needUrgentAction'] = []
          this.quickFilters['needUrgentActionStatuses'] = []
          this.quickFilters['forReview'] = []
        }
      },
      deep: true
    },
    'filter.roundtrips': {
      handler (val) {
        if (val === true) {
          this.quickFilters['roundtrips'] = [ 'active_settings.name', 'eq', 'BackAndForth' ]
        } else {
          this.quickFilters['roundtrips'] = []
        }
      },
      deep: true
    },
    'filter.roundtripLegs': {
      handler (val) {
        if (val === 'forth') {
          this.quickFilters['roundtripForth'] = [ 'depends_on_shipping_id', 'eq', 'null' ]
        } else if (val === 'back') {
          this.quickFilters['roundtripForth'] = [ 'depends_on_shipping_id', 'eq', 'null', 'true' ]
        } else {
          this.quickFilters['roundtripForth'] = []
        }
      },
      deep: true
    },
    'filter.isOutsourced': {
      handler (val) {
        if (val !== null) {
          this.quickFilters['isOutsourced'] = [ 'is_outsourced', 'eq', val ]
        } else {
          this.quickFilters['isOutsourced'] = []
        }
      },
      deep: true
    },
    'filter.courierCompany': {
      handler (val) {
        if (val.length > 0) {
          let companies = val.map(function (item) {
            return item.id
          })
          let companyNames = val.map(function (item) {
            return item.name
          })
          this.quickFilters['courierCompany'] = [[ 'courier_company_id', 'in', companies ], companyNames]
        } else {
          this.quickFilters['courierCompany'] = []
        }
      },
      deep: true
    },
    'filter.warehouse': {
      handler (val) {
        if (val) {
          this.$cookies.set('warehouse', val)
          this.quickFilters['warehouse'] = {
            or: true,
            filters: [
              [ 'from_place_id', 'eq', val ],
              [ 'last_known_place_id', 'eq', val ]
            ]
          }
        } else {
          this.$cookies.remove('warehouse')
          this.quickFilters['warehouse'] = []
        }
      },
      deep: true
    },
    'filter.deliveryTimeRange': {
      handler (val) {
        if (val) {
          if (!this.filter.deliveryTimeRangeNot) {
            this.quickFilters['deliveryTimeRange'] = [ 'delivery_time_range_id', 'eq', val ]
          } else {
            this.quickFilters['deliveryTimeRange'] = {or: true, filters: [[ 'delivery_time_range_id', 'eq', val, true ], [ 'delivery_time_range_id', 'eq', null ]]}
          }
        } else {
          this.quickFilters['deliveryTimeRange'] = []
          this.filter.deliveryTimeRangeNot = false
        }
      },
      deep: true
    },
    'filter.deliveryTimeRangeNot': {
      handler (val) {
        let hack = this.filter.deliveryTimeRange
        this.filter.deliveryTimeRange = null
        this.filter.deliveryTimeRange = hack
      },
      deep: true
    },
    'filter.createdDateRangeActive': {
      handler (val) {
        if (val !== 0) {
          this.quickFilters['createdAtFrom'] = ['created_at', 'gte', this.createdDateRange.startDate.length === 19 ? this.moment(this.createdDateRange.startDate).utc().format('YYYY-MM-DD HH:mm:ss') : this.moment(this.createdDateRange.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
          this.quickFilters['createdAtTo'] = ['created_at', 'lte', this.createdDateRange.endDate.length === 19 ? this.moment(this.createdDateRange.endDate).utc().format('YYYY-MM-DD HH:mm:ss') : this.moment(this.createdDateRange.endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
          this.fullResetUpdatedDateRange()
          this.quickFilters['updatedAtFrom'] = []
          this.quickFilters['updatedAtTo'] = []
          this.filter.updatedDateRangeActive = 0
          this.sortBy = 'created_at'
        } else {
          this.quickFilters['createdAtFrom'] = []
          this.quickFilters['createdAtTo'] = []
        }
      },
      deep: true
    },
    'filter.updatedDateRangeActive': {
      handler (val) {
        if (val !== 0) {
          this.quickFilters['updatedAtFrom'] = ['updated_at', 'gte', this.updatedDateRange.startDate.length === 19 ? this.moment(this.updatedDateRange.startDate).utc().format('YYYY-MM-DD HH:mm:ss') : this.moment(this.updatedDateRange.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
          this.quickFilters['updatedAtTo'] = ['updated_at', 'lte', this.updatedDateRange.endDate.length === 19 ? this.moment(this.updatedDateRange.endDate).utc().format('YYYY-MM-DD HH:mm:ss') : this.moment(this.updatedDateRange.endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
          this.resetCreatedDateRange()
          this.quickFilters['createdAtFrom'] = []
          this.quickFilters['createdAtTo'] = []
          this.filter.createdDateRangeActive = 0
          this.sortBy = 'updated_at'
        } else {
          this.quickFilters['updatedAtFrom'] = []
          this.quickFilters['updatedAtTo'] = []
        }
      },
      deep: true
    },
    'filter.sla': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['sla'] = val
        } else {
          this.quickFilters['sla'] = []
        }
      },
      deep: true
    },
    'quickFilters.updatedAtFrom': {
      handler (val) {
        if (val.length === 3) {
          if (this.moment(val[2]).format('YYYY-MM-DD HH:mm:ss') !== this.moment(this.quickFilters.updatedAtTo[2]).format('YYYY-MM-DD HH:mm:ss')) {
            this.filter.updatedDateRangeActive = 1
          }
        }
      },
      deep: true
    },
    tabIndex(val) {
      if (val === 1) {
        this.checkAdvancedFilters()
      } else if (val === 0) {
        this.checkQuickFilters()
      }
    },
    backofficePreferencesActive(val) {
      this.checkAdvancedFilters()
      this.checkQuickFilters()
    },
    showAreas(val) {
      if (val) {
        this.$refs.fullMap.showAreas = true
      } else {
        this.$refs.fullMap.showAreas = false
      }
      this.$cookies.set('showAreas', val)
    },
    showAreasTooltips(val) {
      if (val) {
        this.$refs.fullMap.showAreasTooltips = true
      } else {
        this.$refs.fullMap.showAreasTooltips = false
        this.showAreas = false
        this.$nextTick(() => {
          this.showAreas = true
        })
      }
      this.$cookies.set('showAreasTooltips', val)
    }
  },
  computed: {
    validateIncidenceDesc() {
      return this.newShippingStatusMeta !== null && this.newShippingStatusMeta.length > 10
    },
    collectionIsSuggestable() {
      let from = [...new Set(this.shippingCollectionObject.map(x => x.last_known_place_id))]
      let to = [...new Set(this.shippingCollectionObject.map(x => x.to_place_id))]
      return (from.length === 1 || to.length === 1)
    },
    collectionIsEditable() {
      return this.shippingCollectionObject.findIndex(x => x.status === 'DELIVERED') === -1 &&
        this.shippingCollectionObject.findIndex(x => x.status === 'CANCELED') === -1 &&
        this.shippingCollectionObject.findIndex(x => x.status === 'RETURNED') === -1
    },
    collectionHas3P() {
      return this.shippingCollectionObject.findIndex(x => x.is_outsourced) !== -1
    },
    clusteringMethodSelectComputed() {
      if (this.collectionIsSuggestable) {
        return this.clusteringMethodSelect.filter(x => {
          return !x.countrize || (x.countrize && this.$frontConfig.clustering && this.$frontConfig.clustering[x.value]) ? x : null
        }).filter(Boolean)
      } else {
        return this.clusteringMethodSelect.filter((x, i) => {
          return i === 0 || i === 1 || (x.countrize && this.$frontConfig.clustering && this.$frontConfig.clustering[x.value]) ? x : null
        }).filter(Boolean)
      }
    },
    noResults() {
      return !this.totalRows || this.totalRows === 0
    },
    outOfDateRange() {
      let updatedDaysRange = Math.floor(this.elapsedTimeRaw(this.updatedDateRange.startDate, this.updatedDateRange.endDate) / (24 * 60 * 60 * 1000))
      let createdDaysRange = Math.floor(this.elapsedTimeRaw(this.createdDateRange.startDate, this.createdDateRange.endDate) / (24 * 60 * 60 * 1000))
      return updatedDaysRange > 90 || createdDaysRange > 90
    },
    noDateRange() {
      return !this.filter.createdDateRangeActive && !this.filter.updatedDateRangeActive
    },
    dataIsMegaRoutable() {
      return this.routingZones && this.routingZones.length > 0 && this.filter.statuses.length === 1 && this.filter.statuses[0] === 'READY'
    },
    dataIs3pable() {
      return this.filter.statuses.length > 0 && this.filter.statuses.length <= 2 && this.filter.statuses.filter(v1 => this.statuses.filter(x => x !== 'READY' && x !== 'READYATSTORE').includes(v1)).length === 0
    }
  },
  mixins: [AddressMixins, ShippingsMixins],
  created() {
    window.copyToClipboard = this.copyToClipboard
    if (!this.$cookies.get('bypassCountry')) {
      this.fetchWarehouses()
      this.fetchAreas()
      this.fetchDeliveryTimeRanges()
      this.fetchRoutingZones()
    }
    this.fetchVehicleTypes()
    this.fetchPlatforms()
    this.fetchShippingTypes()
    this.fetchShippingSizes()
    this.fetchShippingStatusReasons()
    window.addEventListener('popstate', () => {
      if (this.$route.query.s) {
        this.tabIndex = 1
        this.checkAdvancedFilters()
      } else if (this.$route.query.qs) {
        this.tabIndex = 0
        this.checkQuickFilters()
      }
    })
  },
  mounted() {
    this.resetData()
    this.filters = this.preFilters
    this.fields = this.$appConfig.models[this.type].fields
    this.includes = this.$appConfig.models[this.type].includes
    this.exclude = this.$appConfig.models[this.type].exclude
    let that = this
    let fields = this.fields.filter(function (obj) {
      if (that.exclude) {
        return that.exclude.indexOf(obj.key) === -1
      } else {
        return true
      }
    })
    fields.push({ key: 'actions', label: this.$gettext('Actions') })
    this.fields = fields
    if (this.$route.query.s) {
      this.tabIndex = 1
      this.checkAdvancedFilters()
    } else if (this.$route.query.qs) {
      this.checkQuickFilters()
    } else {
      this.refreshTable(initialQuickFilters())
    }
    if (localStorage.savedQuickSearches) {
      this.savedQuickSearches = JSON.parse(localStorage.savedQuickSearches)
    }
    this.initDatePicker()
  },
  methods: {
    initDatePicker() {
      this.locale1 = {
        direction: 'ltr', //  direction of text
        format: 'dd/mm/yyyy', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: 1,
        showWeekNumbers: false //  show week numbers on each row of the calendar
      }
      this.locale2 = {
        direction: 'ltr', //  direction of text
        format: 'dd/mm/yyyy', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: 1,
        showWeekNumbers: false //  show week numbers on each row of the calendar
      }
      this.ranges = { //  default value for ranges object (if you set this to false ranges will no be rendered)
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('This month')]: [this.moment().startOf('month').toDate(), this.moment().endOf('month').toDate()],
        [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week').toDate(), this.moment().subtract(1, 'week').endOf('week').toDate()],
        [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month').toDate(), this.moment().subtract(1, 'month').endOf('month').toDate()]
      }
      this.datepickerLocalized = true
    },
    toggleAllTypes(checked) {
      this.filter.types = checked ? this.shippingTypesSelect.slice().map(x => x.value) : []
    },
    csvUploaded() {
      if (this.$route.query.s) {
        this.tabIndex = 1
        this.checkAdvancedFilters()
      } else if (this.$route.query.qs) {
        this.checkQuickFilters()
      } else {
        this.refreshTable()
      }
    },
    checkAdvancedFilters() {
      // this.quickFilters = []
      if (this.$route.query.s) {
        this.advancedFilters = JSON.parse(this.$route.query.s)
        this.$refs.listingFilters.filters = this.advancedFilters
        console.log(this.advancedFilters)
      }
      this.refreshTable(this.advancedFilters)
    },
    checkQuickFilters() {
      this.advancedFilters = []
      this.$refs.listingFilters.resetData()
      if (this.$route.query.qs) {
        this.quickFilters = JSON.parse(this.$route.query.qs)
        Object.keys(JSON.parse(this.$route.query.qs)).forEach(function (key) {
          // Multi Filters
          if (this.quickFilters[key].filters) {
            this.filter[key] = this.quickFilters[key].filters[0][2]
          } else if (this.quickFilters[key].length > 2 && key !== 'sla') {
            if (key === 'withoutTour') {
              if (this.quickFilters[key].length === 4) {
                this.filter[key] = 'false'
                return
              }
            }
            if (key === 'updatedAtFrom') {
              this.updatedDateRange.startDate = this.quickFilters[key][2]
            }
            if (key === 'updatedAtTo') {
              this.updatedDateRange.endDate = this.quickFilters[key][2]
              this.filter.updatedDateRangeActive = true
            }
            if (key === 'createdAtFrom') {
              this.createdDateRange.startDate = this.quickFilters[key][2]
            }
            if (key === 'createdAtTo') {
              this.createdDateRange.endDate = this.quickFilters[key][2]
              this.filter.createdDateRangeActive = true
            }
            this.filter[key] = this.quickFilters[key][2]
          } else if (this.quickFilters[key].length === 2 && key !== 'sla') {
            this.filter[key] = []
            for (let i = 0; i < this.quickFilters[key][0][2].length; i++) {
              this.filter[key].push({id: this.quickFilters[key][0][2][i], name: this.quickFilters[key][1][i], email: this.quickFilters[key][1][i]})
            }
          }
          if (key === 'sla') {
            this.filter.sla = this.quickFilters[key]
          }
          if (this.quickFilters.statuses && this.quickFilters.statuses.length > 0 && this.quickFilters.statuses[2].indexOf('READY') === -1 && this.quickFilters.statuses[2].indexOf('WAITING') === -1) {
            this.filter.withoutTour = 'indeterminate'
          }
        }.bind(this))
        this.updateQuickFilters()
      }
    },
    updateQuickFilters() {
      if (this.tabIndex === 0) {
        this.currentPage = 1
        let filters = []
        Object.values(this.quickFilters).forEach(function (filter) {
          if (filter.length === 2) {
            filters.push(filter[0])
          } else {
            filters.push(filter)
          }
        })
        if (filters.length > 0) {
          this.$router.push({ query: {qs: this.localizeDates(JSON.stringify(this.quickFilters))} })
        } else {
          this.$router.push('/list/shippings/manual')
        }
        this.refreshTable(filters)
      }
    },
    resetQuickFilters: function () {
      Object.assign(this.$data.filter, initialQuickFilters())
      this.resetUpdatedDateRange()
      this.$nextTick(() => {
        this.updateQuickFilters()
      })
    },
    saveCurrentQuickFilters() {
      let name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (name) {
        this.savedQuickSearches.push({name: 'QUICK: ' + name, url: window.location.href})
      } else {
        alert(this.$gettext('You must write a name for this Filters Set'))
      }
      try {
        localStorage.savedQuickSearches = JSON.stringify(this.savedQuickSearches)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
      this.savedQuickSearches = JSON.parse(localStorage.savedQuickSearches)
    },
    resetAdvancedFilters: function () {
      this.$refs.listingFilters.resetData()
      this.$refs.listingFilters.emitRefresh()
    },
    saveCurrentAdvancedFilters() {
      let name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (name) {
        this.savedQuickSearches.push({name: 'ADVANCED: ' + name, url: window.location.href})
      } else {
        alert(this.$gettext('You must write a name for this Filters Set'))
      }
      try {
        localStorage.savedQuickSearches = JSON.stringify(this.savedQuickSearches)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
      this.savedQuickSearches = JSON.parse(localStorage.savedQuickSearches)
    },
    deleteSavedQuickSearch(index) {
      this.savedQuickSearches.splice(index, 1)
      localStorage.savedQuickSearches = JSON.stringify(this.savedQuickSearches)
      this.savedQuickSearches = JSON.parse(localStorage.savedQuickSearches)
    },
    rowSelected(items) {
      this.selected = items
    },
    selectAll() {
      let shippingsTable = this.$refs.shippingsTable.$el
      let tableBody = shippingsTable.getElementsByTagName('tbody')[0]
      let tableRows = tableBody.getElementsByTagName('tr')
      this.unselectAll()
      for (const row of tableRows) {
        row.click()
      }
    },
    unselectAll() {
      this.$refs.shippingsTable.clearSelected()
    },
    myProvider (ctx) {
      console.log(ctx)

      // Force one date range filters and set sortBy accordingly
      if (ctx.sortBy === 'created_at' && this.filter.updatedDateRangeActive) {
        this.createdDateRange.startDate = this.updatedDateRange.startDate
        this.createdDateRange.endDate = this.updatedDateRange.endDate
        this.filter.updatedDateRangeActive = 0
        this.filter.createdDateRangeActive = 1
        this.filters = this.filters.map(x => {
          if (x[0] === 'updated_at') {
            x[0] = 'created_at'
          }
          return x
        })
      } else if (ctx.sortBy !== 'created_at' && this.filter.createdDateRangeActive) {
        this.updatedDateRange.startDate = this.createdDateRange.startDate
        this.updatedDateRange.endDate = this.createdDateRange.endDate
        this.filter.createdDateRangeActive = 0
        this.filter.updatedDateRangeActive = 1
        this.filters = this.filters.map(x => {
          if (x[0] === 'created_at') {
            x[0] = 'updated_at'
          }
          return x
        })
      } else if (this.tabIndex === 1) {
        if (this.filters.findIndex(x => x[0] === 'created_at') === -1 && this.filters.findIndex(x => x[0] === 'updated_at') === -1) {
          this.filters.push(['updated_at', 'bt', [this.moment().subtract(7, 'days').utc().format('YYYY-MM-DD HH:mm:ss'), this.moment().utc().format('YYYY-MM-DD HH:mm:ss')]])
        }
        if (ctx.sortBy === 'created_at') {
          this.filters = this.filters.map(x => {
            if (x[0] === 'updated_at') {
              x[0] = 'created_at'
            }
            return x
          })
        } else {
          this.filters = this.filters.map(x => {
            if (x[0] === 'created_at') {
              x[0] = 'updated_at'
            }
            return x
          })
        }
      }

      let params = {
        page: ctx.currentPage - 1,
        limit: ctx.perPage,
        includes: this.highPerformanceRequest ? this.$appConfig.models['shippings'].highPerformanceIncludes : this.includes,
        fields: 'from_place_id,last_known_place_id,last_known_place.formatted_address,last_known_place.lat,last_known_place.lng,to_place_id,courier.id,courier.name,courier.email,courier.phone,courier.company_id,courier.tracking,courier.company.name,courier.company.country_iso_code,courier.country_iso_code,courier.roles.name,courier.courier_available.tracking,courier.courier_available.carrying_cash_amount,courier.courier_available.active,previous_shipping.id,following_shippings,threads,id,platform_id,company_id,company.name,user_id,user.name,from_contact,from_phone,from_email,from_country_iso_code,to_contact,to_phone,to_email,to_country_iso_code,email,fields_revision,fields_revision_data,from_address,address_from,from_meta,to_address,address_to,to_meta,instructions,description,items,meta,scheduled_date,delivery_time_range,status,sla_date,updated_at,created_at,courier_commission,price,size_id,shipping_type_id,tags,tour_id,is_outsourced,outsourced_id,courier_company',
        sort: [
          {
            key: ctx.sortBy || 'id',
            direction: ctx.sortDesc ? 'desc' : 'asc'
          }
        ],
        filter_groups: []
      }

      // Backoffice Prefs?
      // if (this.$store.getters.profile.meta) {
      //   const meta = JSON.parse(this.$store.getters.profile.meta)
      //   this.backofficePreferences = meta.backofficePreferences
      //   if (this.backofficePreferences && this.backofficePreferencesActive) {
      //     if (this.backofficePreferences.companies.include.ids.length === 0 && this.backofficePreferences.companies.exclude.ids.length > 0) {
      //       params.filter_groups[0] = {
      //         filters: [
      //           ['company_id', 'in', this.backofficePreferences.companies.exclude.ids, true]
      //         ]
      //       }
      //     } else if (this.backofficePreferences && this.backofficePreferences.companies.include.ids.length > 0) {
      //       params.filter_groups[0] = {
      //         filters: [
      //           ['company_id', 'in', this.backofficePreferences.companies.include.ids]
      //         ]
      //       }
      //     }
      //   }
      // }

      if (this.$cookies.get('filterOwnCompanies') === 'true') {
        params.filter_groups[0] = {
          filters: [
            ['company_operators', 'eq', this.$store.getters.profile.id]
          ]
        }
      }

      if (this.$cookies.get('filterOwnCompaniesSls') === 'true') {
        params.filter_groups[0] = {
          filters: [
            ['company_sellers', 'eq', this.$store.getters.profile.id]
          ]
        }
      }

      let filterByOperator = this.$cookies.get('impersonating')
      if (filterByOperator && filterByOperator.id) {
        params.filter_groups[0] = {
          filters: [
            ['company_operators', 'eq', filterByOperator.id]
          ]
        }
      }

      // Multi Filters
      if (this.filters || this.preFilters) {
        let singleFilters = [...new Set(this.filters)].filter(filter => typeof filter === 'object' && !filter.filters && !filter.filterGroups && ['tomorrow', 'future', 'on-time', 'expired'].indexOf(filter[0]) === -1)
        let multiFilters = [...new Set(this.filters)].filter(filter => typeof filter === 'object' && filter.filters)
        let multiFilterGroups = [...new Set(this.filters)].filter(filter => typeof filter === 'object' && filter.filterGroups)

        if (singleFilters.length > 0) {
          params.filter_groups.push(
            {
              filters: singleFilters || this.preFilters
            }
          )
        }
        if (multiFilters.length > 0) {
          for (const multiFilter of multiFilters) {
            params.filter_groups.push(multiFilter)
          }
        }
        if (multiFilterGroups.length > 0) {
          for (const multiFilterGroup of multiFilterGroups) {
            for (const filterGroup of multiFilterGroup.filterGroups) {
              params.filter_groups.push(filterGroup)
            }
          }
        }
      }
      // HACK :/
      if (this.filter.scheduleds === 'null') {
        params.filter_groups.push(
          {
            'or': true,
            'filters': [{
              'key': 'scheduled_date',
              'value': null,
              'operator': 'eq'
            },
            {
              'key': 'scheduled_date',
              'value': this.moment().endOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
              'operator': 'lte'
            }]
          }
        )
        // params.filter_groups[0].filters.push(['status_history.status', 'in', ['INCIDENCE'], false])
      }
      if (!this.filter.pickupId && !this.filter.shippingId && !this.filter.externalCode) {
        if (this.filter.sla.length === 0) {
          params.filter_groups.push({
            or: true,
            filters: [
              ['sla_date', 'eq', null],
              ['sla_date', 'lte', this.moment.utc().tz(this.$tz).format('YYYY-MM-DD')]
            ]
          })
        } else {
          // MEGA hack :/
          let filterGroups = [
            // {
            //   filters: [
            //     ['status', 'in', ['READY', 'ATPICKUPPOINT', 'INTRANSIT', 'INCIDENCE']]
            //   ]
            // },
            { // sla_date
              or: true,
              filters: []
            }
          ]
          if (this.filter.sla.indexOf('expired') !== -1) {
            filterGroups[0].filters.push(
              ['sla_date', 'lte', this.moment.utc().tz(this.$tz).subtract(1, 'day').format('YYYY-MM-DD')]
            )
          }
          if (this.filter.sla.indexOf('on-time') !== -1) {
            filterGroups[0].filters.push(
              ['sla_date', 'eq', this.moment.utc().tz(this.$tz).format('YYYY-MM-DD')]
            )
          }
          if (this.filter.sla.indexOf('tomorrow') !== -1) {
            filterGroups[0].filters.push(
              ['sla_date', 'eq', this.moment.utc().tz(this.$tz).add(1, 'day').format('YYYY-MM-DD')]
            )
          }
          if (this.filter.sla.indexOf('future') !== -1) {
            filterGroups[0].filters.push(
              ['sla_date', 'gt', this.moment.utc().tz(this.$tz).add(1, 'day').format('YYYY-MM-DD')]
            )
          }
          params.filter_groups = params.filter_groups.concat(filterGroups)
        }
      }

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['from_country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      // console.log(JSON.stringify(params))

      let promise = this.$http.get(ctx.apiUrl, { params: params })

      let csvParams = {...params}
      csvParams.format = 'upload'

      this.csvUrl = {
        url: ctx.apiUrl,
        params: csvParams
      }

      let csvItemsParams = {...params}
      csvItemsParams.format = 'csv'
      csvItemsParams.items = true

      this.csvItemsUrl = {
        url: ctx.apiUrl,
        params: csvItemsParams
      }

      return promise.then((data) => {
        let items = data.body.data.map(x => {
          // console.log(x.id)
          if (x.items && x.items.length > 0) {
            x.itemsToShow = x.items.map(y => {
              if (y.item) {
                y.item.quantity = y.item.quantity || 1
                y.item.description = y.item.description || y.item.name || this.$gettext('No item description')
                y.item.serial_number = y.item.serial_number && Array.isArray(y.item.serial_number) && y.item.serial_number.length > 0 ? y.item.serial_number.join(', ') : null
              } else {
                y.quantity = y.quantity || 1
                y.description = y.description || y.name || this.$gettext('No item description')
                y.serial_number = y.serial_number && Array.isArray(y.serial_number) && y.serial_number.length > 0 ? y.serial_number.join(', ') : null
              }

              return {
                description: y.description || y.item.description || this.$gettext('No item description'),
                quantity: y.quantity || y.item.quantity || 1,
                serial_number: y.serial_number || (y.item && y.item.serial_number ? y.item.serial_number : null)
              }
            })
          } else if (x.meta && x.meta.items && x.meta.items.length > 0) {
            x.itemsToShow = x.meta.items.map(y => {
              if (y.item) {
                y.item.quantity = y.item.quantity || 1
                y.item.description = y.item.description || y.item.name || this.$gettext('No item description')
                y.item.serial_number = y.item.serialNumbers && Array.isArray(y.item.serialNumbers) && y.item.serialNumbers.length > 0 ? y.item.serialNumbers.join(', ') : null
              } else {
                y.quantity = y.quantity || 1
                y.description = y.description || y.name || this.$gettext('No item description')
                y.serial_number = y.serialNumbers && Array.isArray(y.serialNumbers) && y.serialNumbers.length > 0 ? y.serialNumbers.join(', ') : null
              }

              return {
                description: y.description || y.item.description || this.$gettext('No item description'),
                quantity: y.quantity || y.item.quantity || 1,
                serial_number: y.serial_number || (y.item && y.item.serial_number ? y.item.serial_number : null)
              }
            })
          } else {
            x.itemsToShow = []
          }
          x.itemsQuantity = x.itemsToShow ? x.itemsToShow.reduce((a, b) => a + (parseInt(b.quantity) || 1), 0) : null
          return x
        })
        this.selectAllTrigger = false
        this.unselectAll()
        this.totalRows = data.body.pagination.total
        this.shippingViewObject = items

        return (items)
      }).catch(error => {
        console.log(error)
        return []
      })
    },
    refreshTable (filters) {
      this.filters = filters
      setTimeout(() => {
        this.$root.$emit('bv::refresh::table', 'my-table')
      }, 100)
    },
    resetData: function () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.resetUpdatedDateRange()
    },
    addToRoutifier(item) {
      if (this.shippingCollection.indexOf(item.id) === -1) {
        this.shippingCollection.push(item.id)
        this.shippingCollectionObject.push({
          id: item.id,
          from_place_id: item.from_place_id || null,
          from_address: item.address_from ? item.address_from.formatted_address : null,
          from_meta: item.from_meta,
          from_area: item.from_area,
          to_place_id: item.to_place_id || null,
          to_address: item.address_to ? item.address_to.formatted_address : null,
          to_meta: item.to_meta,
          to_area: item.to_area,
          last_known_place_id: item.last_known_place_id,
          last_known_place: item.last_known_place,
          from_lat: item.address_from ? item.address_from.lat : null,
          from_lng: item.address_from ? item.address_from.lng : null,
          to_lat: item.address_to ? item.address_to.lat : null,
          to_lng: item.address_to ? item.address_to.lng : null,
          status: item.status,
          size_id: item.size_id,
          sizeName: this.shippingSizes.find(x => x.id === item.size_id).name,
          meta: item.meta,
          items: item.items || [],
          is_outsourced: item.is_outsourced
        })
        this.addMarker()
      }
    },
    addMarker() {
      let lat
      let lng
      let icon = ''
      let shippings = []
      this.markers = []

      this.shippingCollectionObject.forEach((shipping, i) => {
        switch (shipping.status) {
          case 'DRAFT':
            icon = 'https://avatars.discourse.org/v2/letter/D/FFcc00/24.png'
            break
          case 'WAITING':
            icon = 'https://avatars.discourse.org/v2/letter/W/996600/24.png'
            break
          case 'READY':
            icon = 'https://avatars.discourse.org/v2/letter/R/999999/24.png'
            break
          case 'CONFIRMED':
            icon = 'https://avatars.discourse.org/v2/letter/C/009900/24.png'
            break
          case 'INTRANSIT':
            icon = 'https://avatars.discourse.org/v2/letter/I/009900/24.png'
            break
          case 'INCIDENCE':
            icon = 'https://avatars.discourse.org/v2/letter/I/FFcc00/24.png'
            break
          case 'DELIVERED':
            icon = 'https://avatars.discourse.org/v2/letter/D/000000/24.png'
            break
          default:
            icon = this.$appConfig.staticBaseUrl + 'static/img/ic-map-van-gray.svg'
        }

        lat = shipping.to_lat
        lng = shipping.to_lng

        let infoWindowHtml = this.$gettextInterpolate(this.$gettext('<p>ID: <strong>%{data}</strong></p>'), {data: shipping.id})
        infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>From: <strong>%{data}</strong></p>'), {data: shipping.from_address || ''})
        infoWindowHtml += shipping.from_meta ? this.$gettextInterpolate(this.$gettext('<p>From meta: <strong>%{data}</strong></p>'), {data: shipping.from_meta || ''}) : ''
        infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>Last Known Place: <strong>%{data}</strong></p>'), {data: shipping.last_known_place?.formatted_address || ''})
        infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>To: <strong>%{data}</strong></p>'), {data: shipping.to_address || ''})
        infoWindowHtml += shipping.to_meta ? this.$gettextInterpolate(this.$gettext('<p>To meta: <strong>%{data}</strong></p>'), {data: shipping.to_meta || ''}) : ''
        infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>Current status: <strong>%{data}</strong></p>'), {data: shipping.status})
        infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>Size: <strong>%{data}</strong></p>'), {data: shipping.sizeName})

        shippings.push({
          id: 100000 + i,
          lat: lat,
          lng: lng,
          icon: icon,
          x: 12,
          y: 12,
          infoText: {id: shipping.id, type: 'collection', html: infoWindowHtml},
          popup: true
        })
      })

      this.markers = shippings
      this.addMarkers()
    },
    removeMarker(id) {
      let i = this.markers.findIndex(x => x.infoText.id === id)
      this.markers.splice(i, 1)
      this.addMarkers()
      this.removeFromCollectionById(id)
    },
    addPair() {
      let id = 0
      let shippings = []
      this.pairs = []
      this.markers = []
      this.addMarkers()

      this.shippingCollectionObject.forEach((shipping, i) => {
        let infoWindowHtml = this.$gettextInterpolate(this.$gettext('<p>ID: <strong>%{data}</strong></p>'), {data: shipping.id})
        infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>From: <strong>%{data}</strong></p>'), {data: shipping.from_address || ''})
        infoWindowHtml += shipping.from_meta ? this.$gettextInterpolate(this.$gettext('<p>From meta: <strong>%{data}</strong></p>'), {data: shipping.from_meta || ''}) : ''
        infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>Last Known Place: <strong>%{data}</strong></p>'), {data: shipping.last_known_place?.formatted_address || ''})
        infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>To: <strong>%{data}</strong></p>'), {data: shipping.to_address || ''})
        infoWindowHtml += shipping.to_meta ? this.$gettextInterpolate(this.$gettext('<p>To meta: <strong>%{data}</strong></p>'), {data: shipping.to_meta || ''}) : ''
        infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>Current status: <strong>%{data}</strong></p>'), {data: shipping.status})
        infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>Size: <strong>%{data}</strong></p>'), {data: shipping.sizeName})

        id++
        shippings.push({
          to: {
            id: id,
            lat: shipping.to_lat,
            lng: shipping.to_lng,
            icon: {
              type: 'map-marker',
              size: [27, 36],
              anchor: [13.5, 36],
              color: '#cccccc',
              text: '↓' + shipping.sizeName
            },
            x: 12,
            y: 42,
            infoText: {id: shipping.id, type: 'collection', html: infoWindowHtml},
            popup: true
          },
          from: {
            id: id + 1,
            lat: shipping.last_known_place?.lat || shipping.from_lat,
            lng: shipping.last_known_place?.lng || shipping.from_lng,
            icon: {
              type: 'map-marker',
              size: [27, 36],
              anchor: [13.5, 36],
              color: '#999999',
              text: '↑'
            },
            x: 12,
            y: 42,
            infoText: {id: shipping.id, type: 'collection', html: infoWindowHtml},
            popup: true
          },
          polyLine: true
        })
        id++
      })

      this.pairs = shippings
      this.addPairs()
    },
    removePair(id) {
      let i = this.markers.findIndex(x => x.infoText.id === id)
      this.markers.splice(i, 1)
      this.addMarkers()
      this.removeFromCollectionById(id)
    },
    removeFromCollectionById(id) {
      console.log(this.markers)
      let i = this.markers.findIndex(x => x.infoText.id && x.infoText.id.replace('suggest_', '') === id)
      if (i !== -1) {
        this.markers.splice(i, 1)
        if (this.shippingCollection.indexOf(id) !== -1) {
          this.shippingCollection.splice(this.shippingCollection.indexOf(id), 1)
          this.shippingCollectionObject.splice(this.shippingCollectionObject.findIndex(x => x.id === id), 1)
        }
        this.removeFromClustersById(id)
        this.addMarkers()
      } else {
        i = this.pairs.findIndex(x => x.from.infoText.id === id || x.to.infoText.id === id)
        this.pairs.splice(i, 1)
        this.removeFromRoutifier(i)
        this.addPairs()
      }
    },
    removeFromCollectionByIds(ids, updateMap = true) {
      let index
      let i
      if (this.markers.length > 0) {
        for (i = 0; i < ids.length; i++) {
          index = this.markers.findIndex(x => x.infoText.id === ids[i])
          this.removeFromRoutifier(index)
        }
        if (updateMap) this.addMarkers()
      } else if (this.pairs.length > 0) {
        for (i = 0; i < ids.length; i++) {
          index = this.pairs.findIndex(x => x.from.infoText.id === ids[i] || x.to.infoText.id === ids[i])
          this.pairs.splice(index, 1)
          this.removeFromRoutifier(index)
          if (updateMap) this.addPairs()
        }
      }
    },
    removeFromClustersById(id) {
      this.clusters.forEach((item, i) => {
        let n = item.findIndex(x => x.shipping_id.replace('suggest_', '') === id)
        if (n !== -1) {
          this.clusters[i].splice(n, 1)
          if (this.clusters[i].length === 0) {
            this.clusters.splice(i, 1)
            this.updateClustersMarkers()
          }
        }
      })
    },
    addMarkers(ref = 'fullMap') {
      if (this.$refs[ref]) {
        this.$refs[ref].markers = []
        setTimeout(function () {
          if (this.$refs[ref]) {
            this.checkShowAreas(ref)
            this.$refs[ref].addMarkers(this.markers)
          }
        }.bind(this), 50)
      }
    },
    checkShowAreas(ref) {
      if (this.clusters.length > 0) {
        this.$refs[ref].areas = this.countryAreas
        this.$refs.fullMap.showAreas = this.showAreas = this.$cookies.get('showAreas') === 'true'
        this.$refs.fullMap.showAreasTooltips = this.showAreasTooltips = this.$cookies.get('showAreasTooltips') === 'true'
      }
    },
    addPairs() {
      if (this.$refs.fullMap) {
        setTimeout(function () {
          this.$refs.fullMap.addPairs(this.pairs)
        }.bind(this), 100)
      }
    },
    removeFromRoutifier(i) {
      this.markers.splice(i, 1)
      this.shippingCollection.splice(i, 1)
      this.shippingCollectionObject.splice(i, 1)
    },
    clusterShippingSizes(shippings) {
      let dropoffSizes = shippings.map(x => {
        if (x.type === 'dropoff') {
          return x.package_size
        }
        return null
      }).filter(Boolean)
      let pickupSizes = shippings.map(x => {
        if (x.type === 'pickup') {
          return x.package_size
        }
        return null
      }).filter(Boolean)
      const realSizes = dropoffSizes >= pickupSizes ? dropoffSizes : pickupSizes

      return realSizes.filter(Boolean).reduce(function (counter, item) {
        let p = (String)(item)
        counter[p] = counter.hasOwnProperty(p) ? counter[p] + 1 : 1
        return counter
      }, {})
    },
    clusterShippingsWeight(shippings) {
      return (Math.round(((shippings.reduce((a, b) => {
        return a + (b.package_weight || 0)
      }, 0) / 1000) + Number.EPSILON) * 100) / 100).toFixed(2)
    },
    async sendToSuggest() {
      this.countryAreas = await this.fetchCountryAreas()

      if (this.shippingCollectionObject.length > 1) {
        this.markers = []
        let shippings = this.shippingCollectionObject.map(
          shipping => {
            return this.transformShippingToRoutifierShipping(shipping)
          }
        )

        shippings = await this.checkWeights(shippings)

        let payload = {
          shippings: shippings,
          vehicles: [{
            id: 'vehicle_0',
            start_at: {
              lat: this.shippingCollectionObject[0].from_lat,
              lng: this.shippingCollectionObject[0].from_lng
            },
            vehicle_max_capacity: this.vehicleMaxCapacity,
            vehicle_max_capacity_weight: this.vehicleMaxCapacityWeight * 1000
          }],
          'min_vehicles:packages': 1
        }

        if (this.$frontConfig.clustering && this.$frontConfig.clustering[this.clusteringMethod]) {
          payload.routing_method = this.$frontConfig.clustering[this.clusteringMethod]
        } else if (this.routingMethod) {
          payload.routing_method = this.routingMethod
        }

        if (this.clusteringMethod === 'cluster_vehicle_quantity') {
          for (let i = 0; i < this.routifierCourierCount - 1; i++) {
            payload.vehicles.push({
              id: 'vehicle_' + (i + 1),
              start_at: {
                lat: this.shippingCollectionObject[0].from_lat,
                lng: this.shippingCollectionObject[0].from_lng
              },
              vehicle_max_capacity: this.vehicleMaxCapacity,
              vehicle_max_capacity_weight: this.vehicleMaxCapacityWeight * 1000
            })
          }
        }

        this.$http.post(this.$appConfig.routerApi.baseUrl + this.clusteringMethod, payload)
          .then(response => {
            this.clusters = response.data.solution.map((cluster, n) => {
              let pickups = []
              let dropoffs = []
              cluster.tour.forEach((item, i) => {
                let pickupData = item.type !== 'pickup' ? shippings.find(x => x.id === item.shipping_id).pickup : null
                if (pickupData) {
                  if (pickups.findIndex(x => x.location_id === pickupData.id) === -1) {
                    pickups.push({
                      cluster: item.cluster,
                      coordinates: {
                        lat: pickupData.lat,
                        lng: pickupData.lng
                      },
                      location_id: pickupData.id,
                      shipping_id: item.shipping_id,
                      type: 'pickup',
                      package_size: item.package_size,
                      package_weight: item.package_weight
                    })
                  }
                }
                let dropoffData = item.type !== 'dropoff' ? shippings.find(x => x.id === item.shipping_id).dropoff : null
                if (dropoffData) {
                  if (dropoffs.findIndex(x => x.location_id === dropoffData.id) === -1) {
                    dropoffs.push({
                      cluster: item.cluster,
                      coordinates: {
                        lat: dropoffData.lat,
                        lng: dropoffData.lng
                      },
                      location_id: dropoffData.id,
                      shipping_id: item.shipping_id,
                      type: 'dropoff',
                      package_size: item.package_size,
                      package_weight: item.package_weight
                    })
                  }
                }
              })
              if (n >= this.clusterColors.length) {
                this.clusterColors.push(this.stringToColour((cluster.tour.length * 2343) + (cluster.tour[0].cluster * -13) + cluster.vehicles_id + cluster.tour[0].shipping_id + (cluster.tour[0].cluster * -12) + 'asd' + (cluster.tour[0].cluster * 24) + 'dsa').replace('#', ''))
              }
              return cluster.tour.concat(pickups).concat(dropoffs)
            })

            this.updateClustersMarkers()
          })
      }
    },
    previewTour(cluster, index) {
      this.selectedClusters = [index]

      let result = this.shippingCollectionObject.filter(shipping => cluster.some(clusterShipping => shipping.id === clusterShipping.shipping_id.replace('suggest_', '')))

      let shippings = result.map(
        shipping => {
          return this.transformShippingToRoutifierShipping(shipping)
        }
      )

      let payload = {
        shippings: shippings,
        vehicles: [{
          id: 'vehicle_0',
          start_at: {
            lat: result[0].from_lat,
            lng: result[0].from_lng
          },
          vehicle_max_capacity: this.vehicleMaxCapacity,
          vehicle_max_capacity_weight: this.vehicleMaxCapacityWeight * 1000
        }],
        'min_vehicles:packages': 1
      }

      this.$http.post(this.$appConfig.routerApi.baseUrl + 'route_beststart', payload)
        .then(response => {
          let markers = []
          this.previewTourPolyLines = []
          this.previewTourPolyLines.push({
            polyLine: response.body.solution[0].tour.map(x => {
              return x.coordinates
            }),
            polyLineOptions: {
              strokeWeight: 1,
              strokeColor: '#' + this.clusterColors[0]
            }
          })

          this.previewTourEtc = this.moment.duration(response.body.time_of_completion, 'minutes').format('H:mm')
          this.previewTourFinishTime = this.moment.utc().tz(this.$tz).add(this.previewTourEtc, 'minutes').format('L LT')

          this.$refs.modalPreviewTour.show()
          let n = 0
          response.body.solution[0].tour.forEach((visit, i) => {
            if (markers.findIndex(x => x.lat === visit.coordinates.lat && x.lng === visit.coordinates.lng) === -1) {
              markers.push({
                id: (n + 1),
                lat: visit.coordinates.lat,
                lng: visit.coordinates.lng,
                icon: {
                  type: 'map-marker',
                  size: [27, 36],
                  anchor: [13.5, 36],
                  color: '#' + this.clusterColors[0],
                  text: (n + 1) + (visit.type === 'pickup' ? '↑' : '↓')
                },
                x: 11,
                y: 34,
                infoText: 'ID: ' + visit.shipping_id.replace('suggest_', ''),
                tooltip: true
              })
              n++
            } else {
              markers[markers.findIndex(x => x.lat === visit.coordinates.lat && x.lng === visit.coordinates.lng)].infoText += ',<br>' + visit.shipping_id.replace('suggest_', '')
            }
          })

          this.previewTourMarkers = markers
        })
    },
    addMarkersPreviewTour() {
      this.$refs.previewTourMap.markers = []
      this.$refs.previewTourMap.polyLines = []
      this.$refs.previewTourMap.addMarkers(this.previewTourMarkers)
      this.$refs.previewTourMap.addPolylines(this.previewTourPolyLines)
    },
    transformShippingToRoutifierShipping(shipping) {
      const weight = this.getItemWeight(shipping)

      const formatted = {
        id: 'suggest_' + shipping.id,
        pickup: {
          id: (shipping.last_known_place_id || shipping.from_place_id) + '',
          lat: shipping.last_known_place.lat || shipping.from_lat,
          lng: shipping.last_known_place.lng || shipping.from_lng
        },
        dropoff: {
          id: shipping.to_place_id + '',
          lat: shipping.to_lat,
          lng: shipping.to_lng
        },
        package_size: this.shippingSizes.find(x => x.id === shipping.size_id).name,
        package_weight: weight
      }

      return formatted
    },
    getItemWeight(shipping) {
      if (shipping.meta?.items) {
        return shipping.meta.items.length > 1 ? shipping.meta.items.reduce((a, b) => {
          return a + parseInt(b.weight || (b.item ? b.item.weight || 0 : null))
        }, 0) : (shipping.meta.items.length === 1 ? parseInt(shipping.meta.items[0] ? shipping.meta.items[0].weight : 0) : null)
      } else if (shipping.items?.length) {
        return shipping.items.length > 1 ? shipping.items.reduce((a, b) => {
          return a + parseInt(b.weight || (b.item ? b.item.weight || 0 : null))
        }, 0) : (shipping.items.length === 1 ? parseInt(shipping.items[0] ? shipping.items[0].weight : 0) : null)
      }
      return null
    },
    checkWeights(shippings) {
      const toKeep = shippings.filter(x => x.package_weight !== null)
      const toDelete = shippings.filter(x => x.package_weight === null)
      if (this.clusteringMethod === 'cluster_vehicle_weight' && toDelete.length > 0 && confirm(
        this.$gettextInterpolate(this.$gettext('There are %{qty} shippings WITHOUT WEIGHT in your collection. Should we DELETE them from the Collection before send it to the Clusterizer?'), {qty: toDelete.length})
      )) {
        this.removeFromCollectionByIds(toDelete.map(x => { return x.id.replace('suggest_', '') }), false)
        shippings = toKeep
      }
      return shippings
    },
    openInNewList() {
      const selectedClusters = [...this.selectedClusters]
      selectedClusters.sort(function (a, b) {
        return a - b
      })

      let clusters = [...new Set(this.clusters[selectedClusters[0]])]

      for (let i = selectedClusters.length - 1; i >= 0; i--) {
        if (i !== 0) {
          clusters = [...clusters, ...this.clusters[selectedClusters[i]]]
          this.clusters.splice(selectedClusters[i], 1)
        }
      }
      this.clusters.splice(selectedClusters[0], 1)
      let qs = {
        shippingId: ['id', 'in', [...new Set(clusters.map(x => x.shipping_id.replace('suggest_', '')))]]
      }

      window.open('/list/shippings/manual?qs=' + encodeURIComponent(JSON.stringify(qs)))

      this.shippingCollection = this.shippingCollection.filter(x => [...new Set(clusters.map(x => x.shipping_id.replace('suggest_', '')))].indexOf(x) === -1)
      this.shippingCollectionObject = this.shippingCollectionObject.filter(x => [...new Set(clusters.map(x => x.shipping_id.replace('suggest_', '')))].indexOf(x.id) === -1)

      this.updateClustersMarkers()
    },
    mergeSelectedClusters() {
      const selectedClusters = [...this.selectedClusters]
      selectedClusters.sort(function (a, b) {
        return a - b
      })

      for (let i = selectedClusters.length - 1; i >= 0; i--) {
        if (i !== 0) {
          this.clusters[selectedClusters[0]] = [...this.clusters[selectedClusters[0]], ...this.clusters[selectedClusters[i]]]
          this.clusters.splice(selectedClusters[i], 1)
        }
      }

      this.updateClustersMarkers()
    },
    updateClustersMarkers() {
      this.selectedClusters = []
      this.markers = []
      let infoWindowHtml = ''
      let id = 0
      this.clusters.forEach((cluster, i) => {
        let pickupsCount = cluster.filter(x => x.type === 'pickup').length
        let dropoffsCount = cluster.filter(x => x.type === 'dropoff').length
        let isReverse = pickupsCount >= dropoffsCount
        let iconDropoff = {
          type: 'map-marker',
          size: [27, 36],
          anchor: [13.5, 36],
          color: '#' + this.clusterColors[i],
          text: '↓'
        }
        let iconPickup = {
          type: 'map-marker',
          size: [27, 36],
          anchor: [13.5, 36],
          color: this.pSBC(-0.6, '#' + this.clusterColors[i]),
          text: '↑'
        }
        cluster.forEach((item, n) => {
          id++
          let shipping = this.shippingCollectionObject.find(x => 'suggest_' + x.id === item.shipping_id)
          let infoText
          infoWindowHtml = this.$gettextInterpolate(this.$gettext('<p>ID: <strong>%{data}</strong></p>'), {data: shipping.id})
          infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>From: <strong>%{data}</strong></p>'), {data: shipping.from_address || ''})
          infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>Last Known Place: <strong>%{data}</strong></p>'), {data: shipping.last_known_place.formatted_address || ''})
          infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>To: <strong>%{data}</strong></p>'), {data: shipping.to_address || ''})
          infoWindowHtml += shipping.to_area && shipping.to_area.name ? ' (' + shipping.to_area.name + ')</p>' : ''

          if (!isReverse) {
            infoWindowHtml += item.type === 'dropoff' ? this.$gettextInterpolate(this.$gettext('<p>Cluster: <strong>%{n}</strong></p>'), {n: (i + 1)}) : ''
            infoText = item.type === 'dropoff' ? {id: item.shipping_id.replace('suggest_', ''), type: item.type === 'dropoff' ? 'cluster' : 'shipping', cluster: i, html: infoWindowHtml} : this.$gettextInterpolate(this.$gettext('Cluster %{number} Origin'), {number: (i + 1)})
          } else {
            infoWindowHtml += item.type === 'pickup' ? this.$gettextInterpolate(this.$gettext('<p>Cluster: <strong>%{n}</strong></p>'), {n: (i + 1)}) : ''
            infoText = item.type === 'pickup' ? {id: item.shipping_id.replace('suggest_', ''), type: item.type === 'pickup' ? 'cluster' : 'shipping', cluster: i, html: infoWindowHtml} : this.$gettextInterpolate(this.$gettext('Cluster %{number} Dropoff'), {number: (i + 1)})
          }

          this.markers.push({
            id: id,
            lat: item.coordinates.lat,
            lng: item.coordinates.lng,
            icon: item.type === 'dropoff' ? iconDropoff : iconPickup,
            x: 11,
            y: 34,
            infoText: infoText,
            popup: !isReverse ? item.type === 'dropoff' : item.type !== 'dropoff',
            tooltip: !isReverse ? item.type === 'pickup' : item.type !== 'pickup'
          })
        })
      })

      this.addMarkers()
    },
    selectCluster(i) {
      const selectedClusters = [...this.selectedClusters]
      selectedClusters.push(i)
      this.selectedClusters = [...new Set(selectedClusters)]
    },
    moveToCluster(obj) {
      let replacedDropoff = false
      let replacedPickup = false
      let n
      this.clusters.forEach((item, i) => {
        if (replacedDropoff === false) {
          n = item.findIndex(x => x.shipping_id.replace('suggest_', '') === obj.id && x.type === 'dropoff')
          if (n !== -1) {
            this.clusters[obj.cluster].push(this.clusters[i][n])
            this.clusters[i].splice(n, 1)
            if (this.clusters[i].length === 0) {
              this.clusters.splice(i, 1)
            }
            replacedDropoff = true
          }
        }
        // TODO: refactor this piece of duplicated s**t as there must be another way (the good one)
        if (replacedPickup === false) {
          n = item.findIndex(x => x.shipping_id.replace('suggest_', '') === obj.id && x.type === 'pickup')
          if (n !== -1) {
            this.clusters[obj.cluster].push(this.clusters[i][n])
            this.clusters[i].splice(n, 1)
            if (this.clusters[i].length === 0) {
              this.clusters.splice(i, 1)
            }
            replacedPickup = true
          }
        }
        this.updateClustersMarkers()
      })
    },
    sendClustersToRoutifier() {
      if (
        confirm(this.$gettext('Are you sure you want to SEND the selected Cluster/s to Routifier?'))
      ) {
        const startLocation = {
          lat: this.shippingCollectionObject[0].from_lat,
          lng: this.shippingCollectionObject[0].from_lng
        }
        for (let i = 0; i < this.selectedClusters.length; i++) {
          if (this.clusters[this.selectedClusters[i]].length > 0) {
            let params = {
              'shippings': this.clusters[this.selectedClusters[i]].map(x => x.shipping_id.replace('suggest_', '')),
              'start_location': startLocation,
              'scheduled_date': null,
              'couriersCount': 1
            }
            this.$http.post(this.$appConfig.api.baseUrl + 'tours', params)
              .then(response => {
                for (const tour of response.body) {
                  window.open('/edit/tours/' + tour.id)
                }
                if (i === this.selectedClusters.length - 1) {
                  this.$refs.modalClustersMap.hide()
                  this.clusters = []
                  this.shippingCollection = []
                  this.shippingCollectionObject = []
                  this.routifierCouriers = []
                  this.routifierCourierCount = 1
                  setTimeout(() => {
                    this.$root.$emit('bv::refresh::table', 'my-table')
                    if (this.$refs.modalPreviewTour) {
                      this.$refs.modalPreviewTour.hide()
                    }
                  }, 100)
                }
              }, error => {
                let obj = {
                  title: this.$gettext('ERROR'),
                  message: error.body.message,
                  type: 'error'
                }
                this.$parent.$refs.simplert.openSimplert(obj)
              })
          }
        }
      }
    },
    sendToRoutifier() {
      if (this.shippingCollection.length > 1) {
        this.start_location = {
          lat: this.shippingCollectionObject[0].from_lat,
          lng: this.shippingCollectionObject[0].from_lng
        }
        this.routifierCourierCount = 1 // Force ONE courier for send collection to Routifier
        if (this.routifierCouriers.length > 0 || this.routifierCourierCount !== null) {
          if (
            confirm(this.$gettext('Are you sure you want to SEND the current Collection to Routifier?'))
          ) {
            let params = {
              'shippings': this.shippingCollection,
              'start_location': this.start_location,
              'scheduled_date': null
            }
            if (this.routifierCouriers.length > 0) {
              let courierIds = this.routifierCouriers.map(function (item) {
                return item.id
              })
              params['couriers'] = courierIds
            }
            if (this.routifierCourierCount !== null) {
              params['couriersCount'] = this.routifierCourierCount
            }
            this.$http.post(this.$appConfig.api.baseUrl + 'tours', params).then(response => {
              for (const tour of response.body) {
                window.open('/edit/tours/' + tour.id)
              }
              this.shippingCollection = []
              this.routifierCouriers = []
              this.routifierCourierCount = 1
              setTimeout(() => {
                this.$root.$emit('bv::refresh::table', 'my-table')
              }, 100)
            }, error => {
              let obj = {
                title: this.$gettext('ERROR'),
                message: error.body.message,
                type: 'error'
              }
              this.$parent.$refs.simplert.openSimplert(obj)
            })
          }
        } else {
          alert(this.$gettext('You must set a Couriers Qty. *OR* search and select courier/s by email for the Routifier Collection'))
        }
      } else {
        alert(this.$gettext('Routifier Collection must contain MORE than 1 shipping'))
      }
    },
    clearShippingCollection() {
      if (
        confirm(this.$gettext('Are you sure you want to CLEAR the current Shipping Collection?'))
      ) {
        this.markers = []
        this.shippingCollection = []
        this.shippingCollectionObject = []
        this.routifierCouriers = []
        this.routifierCourierCount = null
      }
    },
    addSelectionToCollection() {
      this.selected.forEach(item => {
        this.addToRoutifier(item)
      })
      this.selectAllTrigger = false
      this.unselectAll()
    },
    onSearchItemSelected(item) {
      this.routifierCouriers.push(item)
      this.searchQuery = ''
    },
    removeCourierFromRoutifier(index) {
      this.routifierCouriers.splice(index, 1)
    },
    async setFromAddress(item) {
      await this.checkPlace(item)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.fromAddressAcInput = this.theCheckedAddress.formatted_address
          this.filter.originAddress = this.theCheckedAddress.id
          // this.start_location = {
          //   lat: this.theCheckedAddress.lat,
          //   lng: this.theCheckedAddress.lng
          // }
        }
        this.theCheckedAddress = {}
      })
    },
    async setToAddress(item) {
      await this.checkPlace(item)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.toAddressAcInput = this.theCheckedAddress.formatted_address
          this.filter.destinationAddress = this.theCheckedAddress.id
          // this.start_location = {
          //   lat: this.theCheckedAddress.lat,
          //   lng: this.theCheckedAddress.lng
          // }
        }
        this.theCheckedAddress = {}
      })
    },
    async setFromAddressCollection(item) {
      await this.checkPlace(item)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.fromAddressAcInputCollection = this.theCheckedAddress.formatted_address
          this.fromAddressCollection = this.theCheckedAddress.id
        }
        this.theCheckedAddress = {}
      })
    },
    async bulkSetFromAddressCollection() {
      if (
        confirm(this.$gettext('Are you sure you want to CHANGE the ORIGIN data for all the shippings into the Collection?'))
      ) {
        this.isLoading = true
        let payload = {}
        if (this.fromAddressCollection) {
          payload.last_known_place_id = this.fromAddressCollection
        }
        if (this.fromContactCollection) {
          payload.from_contact = this.fromContactCollection
        }
        if (this.fromExtraCollection) {
          payload.from_extra = this.fromExtraCollection
        }
        if (this.fromMetaCollection) {
          payload.from_meta = this.fromMetaCollection
        }
        if (this.fromEmailCollection) {
          payload.from_email = this.fromEmailCollection
        }
        if (this.fromPhoneCollection) {
          payload.from_phone = this.fromPhoneCollection
        }
        let promisePatchShippings = []
        for (const shipping of this.shippingCollection) {
          promisePatchShippings.push(this.patchShipping(shipping, payload))
        }
        await Promise.all(promisePatchShippings)
          .then(response => {
            let obj
            if (response.findIndex(x => x.success === false) === -1) {
              obj = {
                title: this.$gettext('SUCCESS'),
                message: this.$gettext('The Collection shippings ORIGIN data have been changed'),
                type: 'success'
              }
            } else {
              let errors = response.filter(x => x.success === false)
              let count = errors.length
              let errorsString = [...new Set(errors.map(x => { return x.error.message }))]
              let errorsCollection = errorsString.map(x => {
                return {
                  message: x,
                  count: errors.filter(y => y.error.message === x).length,
                  ids: errors.filter(y => y.error.message === x).map(y => { return y.id }).join(',')
                }
              })
              let mssg = this.$gettextInterpolate(this.$gettext('The Collection shippings ORIGIN data have been changed but there were %{count} errors to review.<br><br>'), {count: count})
              mssg += this.$gettextInterpolate(this.$gettext('Error types:<br>%{errors}'), {
                errors: errorsCollection.map(x => {
                  return this.$gettextInterpolate(this.$gettext('%{message} <small>(%{count}) <a class="text-primary" onclick="copyToClipboard(\'%{ids}\')">Copy Ids</a></small><br>'), {message: x.message, count: x.count, ids: x.ids})
                })
              })
              obj = {
                title: this.$gettext('WARNING'),
                message: mssg,
                type: 'warning'
              }
            }
            this.$root.$children[0].$refs.simplert.openSimplert(obj)
            this.refreshTable(this.filters)
            this.isLoading = false
          })
      }
    },
    clearFromAddressCollection() {
      this.fromAddressCollection = null
      this.fromAddressAcInputCollection = ''
      this.fromContactCollection = null
      this.fromExtraCollection = null
      this.fromMetaCollection = null
      this.fromEmailCollection = null
      this.fromPhoneCollection = null
    },
    async setToAddressCollection(item) {
      await this.checkPlace(item)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.toAddressAcInputCollection = this.theCheckedAddress.formatted_address
          this.toAddressCollection = this.theCheckedAddress.id
        }
        this.theCheckedAddress = {}
      })
    },
    preBulkSetToAddressCollection() {
      if (
        confirm(this.$gettext('Are you sure you want to CHANGE the DESTINATION for all the shippings into the Collection?'))
      ) {
        let obj = {
          title: this.$gettext('WARNING'),
          message: this.$gettext('Are you <strong><big>REALLY REALLY SURE</big></strong> you want to <strong><big>CHANGE the DESTINATION</big></strong> for all the shippings into the Collection?'),
          type: 'warning',
          useConfirmBtn: true,
          customConfirmBtnText: this.$gettext('HELL YES! I\'M SURE!'),
          customConfirmBtnClass: 'btn btn-success',
          onConfirm: this.bulkSetToAddressCollection,
          customCloseBtnText: this.$gettext('NO! I\'M NOT!'),
          customCloseBtnClass: 'btn btn-danger'
        }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
      }
    },
    async bulkSetToAddressCollection() {
      this.isLoading = true
      let payload = {to_place_id: this.toAddressCollection}
      let promisePatchShippings = []
      for (const shipping of this.shippingCollection) {
        promisePatchShippings.push(this.patchShipping(shipping, payload))
      }
      await Promise.all(promisePatchShippings)
        .then(response => {
          let obj
          if (response.findIndex(x => x.success === false) === -1) {
            obj = {
              title: this.$gettext('SUCCESS'),
              message: this.$gettext('The Collection shippings now ENDS into your selected location'),
              type: 'success'
            }
          } else {
            let errors = response.filter(x => x.success === false)
            let count = errors.length
            let errorsString = [...new Set(errors.map(x => { return x.error.message }))]
            let errorsCollection = errorsString.map(x => {
              return {
                message: x,
                count: errors.filter(y => y.error.message === x).length,
                ids: errors.filter(y => y.error.message === x).map(y => { return y.id }).join(',')
              }
            })
            let mssg = this.$gettextInterpolate(this.$gettext('The Collection shippings now ENDS into your selected location but there were %{count} errors to review.<br><br>'), {count: count})
            mssg += this.$gettextInterpolate(this.$gettext('Error types:<br>%{errors}'), {
              errors: errorsCollection.map(x => {
                return this.$gettextInterpolate(this.$gettext('%{message} <small>(%{count}) <a class="text-primary" onclick="copyToClipboard(\'%{ids}\')">Copy Ids</a></small><br>'), {message: x.message, count: x.count, ids: x.ids})
              })
            })
            obj = {
              title: this.$gettext('WARNING'),
              message: mssg,
              type: 'warning'
            }
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
          this.refreshTable(this.filters)
          this.isLoading = false
        })
    },
    async patchShipping(id, payload) {
      try {
        let shipping = await this.$http.patch(this.$appConfig.api.baseUrl + 'shippings/' + id, payload)
        return {success: true, id: shipping.body.id}
      } catch (e) {
        this.$root.$children[0].$refs.simplert.justCloseSimplert()
        return {success: false, id: id, error: {status: e.status, message: e.body.message}, _rowVariant: 'danger'}
      }
    },
    bulkRecalculateBudget() {
      if (
        confirm(this.$gettext('Are you sure you want to RECALCULATE the Budgets for all the shippings into the Collection??'))
      ) {
        let n = 0
        for (let i = 0; i < this.shippingCollection.length; i++) {
          this.$http.put(this.$appConfig.api.baseUrl + 'shippings/' + this.shippingCollection[i] + '/budget/recalculate')
            .then(response => {
              n++
              if (n === this.shippingCollection.length) {
                let obj = {
                  title: this.$gettext('SUCCESS'),
                  message: this.$gettext('The Budgets into the Collection have been recalculated'),
                  type: 'success'
                }
                this.$root.$children[0].$refs.simplert.openSimplert(obj)
                this.refreshTable(this.filters)
              }
            })
        }
      }
    },
    closeModal(modalRef) {
      this.$refs[modalRef].hide()
    },
    addressFixed(modalRef) {
      this.$emit('shippingupdated', this.shipping)
      this.refreshTable(this.filters)
      this.closeModal(modalRef)
    },
    onSearchTagSelected(item) {
      this.filter.tag.push({name: item.name})
      this.$refs.tagAc.searchQuery = ''
    },
    removeTagFromFilters(index) {
      this.filter.tag.splice(index, 1)
    },
    onSearchCompanySelected(item) {
      this.filter.company.push({id: item.id, name: item.name})
      this.$refs.companyAc.searchQuery = ''
    },
    removeCompanyFromFilters(index) {
      this.filter.company.splice(index, 1)
    },
    onSearchCourierCompanySelected(item) {
      this.filter.courierCompany.push({id: item.id, name: item.name})
      this.$refs.courierCompanyAc.searchQuery = ''
    },
    removeCourierCompanyFromFilters(index) {
      this.filter.courierCompany.splice(index, 1)
    },
    onSearchCourierSelected(item) {
      this.filter.courier.push({id: item.id, email: item.email})
      this.$refs.courierAc.searchQuery = ''
    },
    removeCourierFromFilters(index) {
      this.filter.courier.splice(index, 1)
    },
    onSearchClientSelected(item) {
      this.filter.client.push({id: item.id, email: item.email})
      this.$refs.userAc.searchQuery = ''
    },
    removeClientFromFilters(index) {
      this.filter.client.splice(index, 1)
    },
    resetCreatedDateRange() {
      this.createdDateRange = {
        startDate: this.moment(),
        endDate: this.moment()
      }
      this.filter.createdDateRangeActive = 0
    },
    resetUpdatedDateRange() {
      this.updatedDateRange = {
        startDate: this.moment.utc().tz(this.$tz).subtract(7, 'days').startOf('day'),
        endDate: this.moment.utc().tz(this.$tz).endOf('day')
      }
      this.filter.updatedDateRangeActive = 1
    },
    fullResetUpdatedDateRange() {
      this.updatedDateRange = {
        startDate: this.moment(),
        endDate: this.moment()
      }
      this.filter.updatedDateRangeActive = 0
    },
    onStatusSearchCourierSelected(item) {
      this.statusCourier = item
      this.$refs.statusCourierAc.searchQuery = ''
    },
    async updateStatus() {
      if (this.shippingCollection.length > 1) {
        if (this.newShippingStatus !== 'CONFIRMED' || (this.newShippingStatus === 'CONFIRMED' && (this.statusCourier && this.statusCourier.id))) {
          if (
            confirm(this.$gettext('Are you sure you want to CHANGE the current Collection statuses?'))
          ) {
            this.isLoading = true
            const chunkSize = 40
            let completeCollection = [...new Set(this.shippingCollection)]
            const chunks = [...Array(Math.ceil(this.shippingCollection.length / chunkSize))].map(_ => completeCollection.splice(0, chunkSize))
            for (let i = 0; i < chunks.length; i++) {
              await this.doUpdateStatus(chunks[i])
                .then(response => {
                  if (i === (chunks.length - 1)) {
                    setTimeout(() => {
                      this.$root.$emit('bv::refresh::table', 'my-table')
                    }, 100)
                    this.reScheduledAt = null
                    this.newShippingStatus = null
                    this.newShippingStatusMeta = null
                    this.incidenceDetails = {}
                    this.isLoading = false
                  }
                }, error => {
                  let obj = {
                    title: this.$gettext('ERROR'),
                    message: error.body.message,
                    type: 'error'
                  }
                  this.$parent.$refs.simplert.openSimplert(obj)
                  if (i === (chunks.length - 1)) {
                    setTimeout(() => {
                      this.$root.$emit('bv::refresh::table', 'my-table')
                    }, 100)
                    this.reScheduledAt = null
                    this.newShippingStatus = null
                    this.newShippingStatusMeta = null
                    this.incidenceDetails = {}
                    this.isLoading = false
                  }
                })
            }
          }
        } else {
          alert(this.$gettext('You MUST select a courier before change Shippings Status to CONFIRMED'))
        }
      } else {
        alert(this.$gettext('The Collection must contain MORE than 1 shipping'))
      }
    },
    async doUpdateStatus(shippingCollection) {
      let params
      this.reScheduledAt = this.reScheduledAt && this.reScheduledAt.split('-')[0] >= 1000 ? this.reScheduledAt + ' 00:00:00' : null
      if (this.newShippingStatus === 'READY' && this.reScheduledAt) {
        let utcDate = this.moment(this.reScheduledAt).utc().format('YYYY-MM-DD HH:mm:ss')
        console.log(utcDate)
        params = {
          shippings: shippingCollection,
          user_id: this.$store.getters.profile.id,
          status: this.newShippingStatus,
          meta: 'RESCHEDULED AT ' + utcDate + ' UTC'
        }

        await this.$http.post(this.$appConfig.api.baseUrl + 'shippings/statuses', params)
          .then(async response => {
            let statuses = response.body
            let reschedules = []
            for (let i = 0; i < statuses.length; i++) {
              let shipping = {
                scheduled_date: utcDate,
                instructions: 'RESCHEDULED ' + this.shippingViewObject.find(x => x.id === statuses[i].shipping_id).instructions
              }
              reschedules.push(this.$http.patch(this.$appConfig.api.baseUrl + 'shippings/' + this.shippingCollection[i], shipping))
            }
            await Promise.all(reschedules)
          })
      } else {
        params = {
          shippings: shippingCollection,
          user_id: this.$store.getters.profile.id,
          status: this.newShippingStatus,
          meta: this.newShippingStatusMeta || null
        }
        if (this.newShippingStatus === 'CONFIRMED' && this.statusCourier && this.statusCourier.id) {
          params.courier_id = this.statusCourier.id
        }
        if (this.newShippingStatus === 'INCIDENCE') {
          params.details = this.incidenceDetails
        }
        if (this.newShippingStatus === 'TOBERETURNED') {
          params.details = this.tobereturnedDetails
        }
        if (this.newShippingStatus === 'DELIVERED') {
          params.details = this.deliveredStatusDetailFields
        }
        if (this.newShippingStatus === 'CANCELED') {
          params.details = this.cancelDetails
        }
        if (params.details && params.details.reason_id) {
          params.shipping_status_reasons_id = params.details.reason_id
        }

        return await this.$http.post(this.$appConfig.api.baseUrl + 'shippings/statuses', params)
      }
    },
    downloadCsv() {
      this.$http.get(this.csvUrl.url, {params: this.csvUrl.params})
        .then(response => {
          let obj = {
            title: this.$gettext('JOB DISPATCHED'),
            message: this.$gettext('The Report is being generated, you will receive an email with a link to download it as soon as it\'s done'),
            type: 'success'
          }
          this.$root.$children[0].$refs.simplert.openSimplert(obj)
        })
    },
    downloadItemsCsv() {
      let data = {
        url: this.csvItemsUrl.url,
        params: this.csvItemsUrl.params,
        type: 'text/csv;charset=utf-8;',
        filename: this.moment().local().format('YYYY-MM-DD_HH-mm') + '__items_export'
      }
      this.downloadAsync(data)
    },
    getShippingLabel(shipping) {
      this.$http.get(this.$appConfig.api.baseUrl + 'shippings/' + shipping.id + '/label')
        .then(response => {
          let labelUrl = response.body.label
          window.open(labelUrl, 'label__' + shipping.id)
        })
    },
    initMap(shippingId) {
      this.getShipping(shippingId)
      this.intervalShippingMap = setInterval(function () {
        this.getShipping(shippingId)
      }.bind(this), 5000)
    },
    killMap() {
      this.markersShipping = []
      clearInterval(this.intervalShippingMap)
    },
    circlePicked(e) {
      this.filter.nearOrigin = {...e}
      this.$refs.modalCirclePicker.hide()
    },
    getShipping(shippingId) {
      this.$http.get(this.$appConfig.api.baseUrl + 'shippings/' + shippingId, {params: {includes: ['courier.courier_available.tracking']}})
        .then(response => {
          let noCourierYet = this.markers.length === 2 || false

          this.markersShipping = []
          this.markersShipping.push({
            id: 'm0',
            lat: response.body.address_from.lat,
            lng: response.body.address_from.lng,
            icon: this.$appConfig.staticBaseUrl + 'static/img/ic_origin_on.svg',
            x: 12,
            y: 12,
            infoText: this.$gettext('Origin'),
            tooltip: true
          })
          this.markersShipping.push({
            id: 'm1',
            lat: response.body.address_to.lat,
            lng: response.body.address_to.lng,
            icon: this.$appConfig.staticBaseUrl + 'static/img/ic_destination_on.svg',
            x: 12,
            y: 12,
            infoText: this.$gettext('Destination'),
            tooltip: true
          })

          if (response.body.current_tracking !== null) {
            let icon = this.$appConfig.staticBaseUrl + 'static/img/ic-map-' + this.vehicleTypes.find(x => x.id === response.body.courier.courier_available.vehicle_type_id).name.toLowerCase() + '-gray.svg'
            if (noCourierYet) {
              this.fitted = false
            }
            this.markersShipping.push({
              id: 'm2',
              lat: response.body.current_tracking.lat,
              lng: response.body.current_tracking.lng,
              icon: icon,
              x: 25,
              y: 25,
              infoText: this.$gettext('Courier'),
              tooltip: true
            })
          }
          this.$refs.shippingMap.addMarkers(this.markersShipping)
          if (this.fitted === false) {
            this.$refs.shippingMap.fitted = false
            this.fitted = true
          }
        })
    },
    async fetchCountryAreas() {
      let params = {}

      if (window.country !== null && !this.$cookies.get('bypassCountry')) {
        params = {
          filter_groups: [{
            filters: [
              ['country_iso_code', 'eq', window.country]
            ]
          }]
        }
        return await this.$http.get(this.$appConfig.api.baseUrl + 'routing-zones', {params: params})
          .then(response => {
            return response.body.data.map(area => {
              return {
                text: area.code || area.name,
                value: {
                  coords: JSON.parse(JSON.stringify(area.area)).coordinates.map(linearRing =>
                    linearRing.slice(0, linearRing.length - 1)
                      .map(([lng, lat]) => ({lat, lng}))
                  )
                }
              }
            }).filter(Boolean)
          })
      } else {
        return []
      }
    },
    async cancel3POutsource() {
      this.isLoading = true
      let promise = []
      for (const shippingId of this.shippingCollection) {
        promise.push(this.cancel3p({id: shippingId}))
      }
      await Promise.all(promise).then(() => {
        setTimeout(() => {
          this.$root.$emit('bv::refresh::table', 'my-table')
          this.isLoading = false
        }, 100)
      })
    }
  }
}
</script>

<style lang="scss">
.filter-actions .badge {
  padding:.4rem;
  cursor: pointer
}
.routifier-collection, .filters {
  .badge {
    margin: 2px;
  }
}
.shipping-address-listings {
  font-size: 14px;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 200px;
}
#modalCollectionMap {
  .modal-body {
    padding: 0 0 20px;
  }
}
.tooltip-3p {
  .tooltip-inner {
    max-width: fit-content !important;
  }
}
</style>
